import {loadSprites, loadTitleSprites} from "./sprites.js";
import {captureError, getHairColor, getRandomChoice, getRandomInt} from "../modules/helpers.js";
import {objectEquals} from "./ui-helpers.js";
import {rateTemplateSuperstarRequest, runTemplateSuperstarsEditorSearch} from "./community.js";

// PIXI settings
let spritesVersion = '1.68';
PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
PIXI.loader.defaultQueryString = 'v=' + spritesVersion;
PIXI.loader.add("static/www/static/images/sprites/sprites.json");
PIXI.utils.skipHello();

// Define variables
let resourcesLoaded = false;
let renderer;
let stage;
let characterBackgroundImage = 'static/www/static/images/dark_background.png';

function changeCharacterBackgroundImage(theme) {
    if (theme === 'light') {
        characterBackgroundImage = null
    }
    else {
        characterBackgroundImage = 'static/www/static/images/dark_background.png'
    }
}

function showTalentInformationGraphic(graphicData, el, matchData) {
    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(300, 300);
    renderer.autoResize = true;

    // Add the canvas to the HTML document
    el.append(renderer.view);

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    renderer.backgroundColor = 0xF7F7F7;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }

    // Render the stage
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    renderer.view.style.width = 110;
    renderer.view.style.height = 110;
    stage.position.set(renderer.width / 2, renderer.height / 2);
    stage.scale.set(1.49, 1.49);
    stage.pivot.set(144, 145);

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicData, matchData, el, false);
}

function resetCommunityGraphicsGraphic(el) {
    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(300, 300);
    renderer.autoResize = true;

    // Add the canvas to the HTML document
    el.append(renderer.view);

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    renderer.backgroundColor = 0xEFEFEF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }

    // Render the stage
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    renderer.view.style.width = 120;
    renderer.view.style.height = 200;
    stage.scale.set(2.5, 1.5);
    stage.pivot.set(83, 45);

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, null, null, el);
}

function showFactionInformationGraphic(graphicData, el, matchData) {
    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(300, 300);
    renderer.autoResize = true;

    // Add the canvas to the HTML document
    el.append(renderer.view);

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    renderer.backgroundColor = 0xF7F7F7;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }

    // Render the stage
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    let height = 145;
    let width = 350;
    renderer.view.style.width = width;
    renderer.view.style.height = height;
    stage.position.set(renderer.width / 2, renderer.height / 2);
    let scaleHeight = 1.45;
    let scaleWidth = (height / width) * scaleHeight;
    stage.scale.set(scaleWidth, scaleHeight);
    stage.pivot.set(250, 145);

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicData, matchData, el, false);
}

function showChampionshipInformationGraphic(graphicData, el) {
    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(200, 100);
    renderer.autoResize = true;

    // Remove previous canvas
    el.html('');

    // Add the canvas to the HTML document
    el.append(renderer.view);

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    renderer.backgroundColor = 0xF7F7F7;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }

    // Render the stage
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    renderer.view.style.width = 200;
    renderer.view.style.height = 100;
    stage.scale.set(0.5, 0.5);

    // Show canvas
    el.show();

    loadTitleGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicData, el);
}

function showRosterMemberPageGraphic(graphicData, el, matchData) {
    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(300, 300);
    renderer.autoResize = true;

    // Add the canvas to the HTML document
    el.append(renderer.view);

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xEFEFEF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    renderer.view.style.width = 145;
    renderer.view.style.height = 145;
    stage.position.set(renderer.width / 2, renderer.height / 2);
    stage.scale.set(1.45, 1.45);
    stage.pivot.set(144, 145);

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicData, matchData, el, false);

    // Hide attire buttons for tagTeam
    if (matchData && matchData['type'] === 'tag') {
        $('#roster-member-details').find('.attire-select-button').hide()
    }
    else {
        $('#roster-member-details').find('.attire-select-button').show()
    }
}

function resetAddSuperstarGraphic(el) {
    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(300, 300);
    renderer.autoResize = true;

    // Add the canvas to the HTML document
    el.append(renderer.view);

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xEFEFEF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    renderer.view.style.width = 300;
    renderer.view.style.height = 300;

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, null, null, el);
}

function showTalentDialogPageGraphic(el, graphic, request = false, annualTournament = false) {
    // Reset renderer
    if (renderer) {
        if (annualTournament) {
            if (renderer.secondary) {
                renderer.destroy()
            }
        }
        else {
            renderer.destroy()
        }
    }
    renderer = PIXI.autoDetectRenderer(300, 300);
    renderer.autoResize = true;
    if (annualTournament) {
        renderer.secondary = true
    }

    // Remove previous canvas
    el.html('');

    // Add the canvas to the HTML document
    el.append(renderer.view);

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xFFFFFF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    if (request || annualTournament) {
        renderer.view.style.width = 90;
        renderer.view.style.height = 100;
    } else {
        renderer.view.style.width = 100;
        renderer.view.style.height = 116;
    }
    stage.scale.set(5, 5);
    let yPivot = 55;
    if (annualTournament) {
        yPivot = 58
    }
    stage.pivot.set(113, yPivot);

    // Show canvas
    el.show();

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphic, null, el);
}

function showDialogPersonGraphic(graphicData, el) {
    // Reset renderer
    if (renderer && renderer.secondary) {
        renderer.destroy();
    }
    renderer = PIXI.autoDetectRenderer(300, 300);
    renderer.autoResize = true;
    renderer.secondary = true;

    // Remove previous canvas
    el.html('');

    // Add the canvas to the HTML document
    el.append(renderer.view).hide();

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xFFFFFF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    renderer.view.style.width = 90;
    renderer.view.style.height = 100;

    stage.scale.set(5, 5);
    stage.pivot.set(113, 58);

    // Show canvas
    el.show();

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicData, null, el);
}

function showScenarioEditorSuperstarGraphic(graphicData, el) {
    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(300, 300);
    renderer.autoResize = true;

    // Add the canvas to the HTML document
    el.append(renderer.view); // .hide()

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xEFEFEF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    renderer.view.style.width = 300;
    renderer.view.style.height = 300;
    stage.pivot.set(0, 10);

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicData, null, el);
}

function showStaffMemberPageGraphic(graphic, el) {
    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(300, 300);
    renderer.autoResize = true;

    // Add the canvas to the HTML document
    el.append(renderer.view);

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xEFEFEF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    renderer.view.style.width = 145;
    renderer.view.style.height = 145;
    stage.position.set(renderer.width / 2, renderer.height / 2);
    stage.scale.set(1.45, 1.45);
    stage.pivot.set(144, 145);

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, [graphic], null,
        el, false);
}

function showChangeAppearancePageGraphic(el) {
    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(300, 300);
    renderer.autoResize = true;

    // Remove previous canvas
    el.html('');

    // Add the canvas to the HTML document
    el.append(renderer.view).hide();

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xEFEFEF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);
    renderer.view.style.width = 300;
    renderer.view.style.height = 300;

    // Show canvas
    el.show();

    let graphic = JSON.parse(el.data('key'));
    let graphicList;
    if (graphic) {
        graphicList = [graphic]
    }

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicList, null, el);

    // Show controls
    el.next('.character-creator-controls').show();
    $('.sp-replacer').addClass('grey-background');
}

function showFactionDetailsPageGraphic(graphicData, el, matchData) {
    // Reset renderer
    if (renderer) {
        renderer.destroy();
    }
    renderer = PIXI.autoDetectRenderer(430, 300);
    renderer.autoResize = true;

    // Add the canvas to the HTML document
    el.append(renderer.view);

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xFFFFFF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x1B1B1B
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicData, matchData, el, false);
}

function showTitlePageGraphic(el, graphicData) {
    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(400, 200);
    renderer.autoResize = true;

    // Remove previous canvas
    el.html('');

    // Add the canvas to the HTML document
    el.append(renderer.view).hide();

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xF9F9F9;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);
    renderer.view.style.width = 370;
    renderer.view.style.height = 185;

    // Show canvas
    el.show();

    loadTitleGraphic(stage, stageObjects, stageLayers, stageBackground, layer, [graphicData], el);
}

function showAddChampionshipPageGraphic(el, graphicData) {

    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(400, 200);
    renderer.autoResize = true;

    // Remove previous canvas
    el.html('');

    // Add the canvas to the HTML document
    el.append(renderer.view).hide();

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xEFEFEF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);
    renderer.view.style.width = 400;
    renderer.view.style.height = 200;
    stage.pivot.set(0, 0);

    // Show canvas
    el.show();

    loadTitleGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicData, el);
}

function showScenarioEditorChampionshipGraphic(graphicData, el) {

    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(300, 150);
    renderer.autoResize = true;

    // Remove previous canvas
    el.html('');

    // Add the canvas to the HTML document
    el.append(renderer.view).hide();

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xEFEFEF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);
    renderer.view.style.width = 300;
    renderer.view.style.height = 150;
    stage.scale.set(0.75, 0.75);

    loadTitleGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicData, el);
}

function showCustomStartingCompanyChampionshipGraphic(el, graphicData) {

    // Reset renderer
    if (renderer) {
        renderer.destroy()
    }
    renderer = PIXI.autoDetectRenderer(300, 150);
    renderer.autoResize = true;

    // Remove previous canvas
    el.html('');

    // Add the canvas to the HTML document
    el.append(renderer.view).hide();

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xEFEFEF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x353535
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);
    renderer.view.style.width = 300;
    renderer.view.style.height = 150;
    stage.scale.set(0.75, 0.75);

    // Show canvas
    el.show();

    loadTitleGraphic(stage, stageObjects, stageLayers, stageBackground, layer, graphicData, el);
}

function loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, jsonData, match, el, showPalette,
                     segmentAction, posterData) {

    let graphicsParent = el.parent();
    if (typeof(showPalette) === 'undefined') showPalette = true;
    if (typeof(jsonData) === 'undefined') jsonData = null;
    if (typeof(match) === 'undefined') match = null;
    if (typeof(el) === 'undefined' || el === null) {
        el = $('.select-part')
    }
    else {
        el = el.siblings('.character-creator-controls').find('.select-part')
    }
    if (typeof(segmentAction) === 'undefined') segmentAction = null;
    if (typeof(posterData) === 'undefined') posterData = null;

    // Reset attires
    graphicsParent.find('.attire-select-button').data('graphicJson', null);

    // Select "A" attire
    graphicsParent.find('.attire-select-button.selected').removeClass('selected');
    graphicsParent.find('.attire-select-button:contains("A")').addClass('selected');
    $('.part-button.disabled').removeClass('disabled');
    $('.remove-attire-button').hide();

    // Add alternate attires
    let attireButtons = [graphicsParent.find('.attire-select-button:contains("B")'),
        graphicsParent.find('.attire-select-button:contains("C")')];
    if (jsonData) {
        let alternateAttires;
        try {
            alternateAttires = jsonData[0]['alternate_attires'];
        } catch (error) {
            captureError(error)
        }

        if (alternateAttires) {
            alternateAttires.forEach(function (attire, i) {
                attireButtons[i].data('graphicJson', JSON.stringify(attire));
            });
        }
        // Add base attire
        graphicsParent.find('.attire-select-button:contains("A")').data('graphicJson', JSON.stringify(jsonData[0]));
    }

    // Run setup if resources loaded, otherwise wait for load event (first time)
    PIXI.loader.on('complete', function () {
        resourcesLoaded = true;
    });
    if (resourcesLoaded) {
        // Unbind click handlers
        $('.character-creator-controls *').off();
        setup();
    }
    else {
        PIXI.loader.load(setup);
    }

    function setup() {

        // Initialize spectrum color picker
        if (showPalette) {
            el.next('.part-controls').find(".spectrum").spectrum({
                showPalette: true,
                palette: [
                    ["#000", "#444", "#666", "#999", "#ccc", "#eee", "#f3f3f3", "#fff"],
                    ["#f00", "#f90", "#ff0", "#0f0", "#0ff", "#00f", "#90f", "#f0f"],
                    ["#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#d9d2e9", "#ead1dc"],
                    ["#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#b4a7d6", "#d5a6bd"],
                    ["#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8e7cc3", "#c27ba0"],
                    ["#c00", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3d85c6", "#674ea7", "#a64d79"],
                    ["#900", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#0b5394", "#351c75", "#741b47"],
                    ["#600", "#783f04", "#7f6000", "#274e13", "#0c343d", "#073763", "#20124d", "#4c1130"],
                    ["#FFE4CB", "#F4D7BC", "#FFD9B6", "#FFD4AB", "#F2D2A5", "#DFB58D", "#CAA684", "#7A6353"]
                ],
                preferredFormat: "hex",
                color: "#F7D1B9",
                showInitial: true,
                showInput: true,
                showButtons: false
            });
        }

        // Add grey background to gimmick graphic spectrum
        $('#create-gimmick-graphic-container').find('.sp-replacer').addClass('grey-background');
        $('#change-appearance-graphic-container').find('.sp-replacer').addClass('grey-background');
        $('#change-staff-appearance-graphic-container').find('.sp-replacer').addClass('grey-background');
        $('#add-superstar').find('.sp-replacer').addClass('grey-background');

        const sprites = loadSprites();

        let parts = {
            'accessory': sprites.accessories,
            'bottoms': sprites.bottoms,
            'torso': sprites.torsos,
            'hair': sprites.hairs,
            'shoes': sprites.shoes,
            'elbow': sprites.elbows,
            'facialHair': sprites.facialHairs,
            'body': sprites.bodies,
            'accessory2': sprites.accessories,
            'accessory3': sprites.accessories,
            'knee': sprites.kneepads,
            'facepaint': sprites.facepaints,
            'tattoo': sprites.tattoos,
            'eyes': sprites.eyes,
            'blood': sprites.bloodObjects,
            'weapon': sprites.weaponObjects,
            'temporaryInjury': sprites.temporaryInjuryObjects,
            'temporaryTrophy': sprites.temporaryTrophyObjects
        };
        let selected;
        let selectedPart;
        let selections = sprites.bodies;

        // Set positions
        sprites.bodies.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(103, 68);
            })
        }); // 77 originally
        sprites.bottoms.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(121, 159);
            })
        });
        sprites.trunks.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(121, 159);
            })
        });
        sprites.shorts.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(121, 161);
            })
        });
        sprites.tights.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(121, 160);
            })
        });
        sprites.feminineBottoms.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(121, 158);
            })
        });
        sprites.torsos.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(94, 98);
            })
        });
        sprites.hairs.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(103, 50);
            })
        });
        sprites.shoes.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(118, 197);
            })
        });
        sprites.elbows.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(100, 128);
            })
        });
        sprites.facialHairs.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(121, 68);
            })
        });
        sprites.accessories.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(94, 50);
            })
        });
        sprites.flags.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(94, -9);
            })
        });
        sprites.allFacepaints.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(125, 66);
            })
        });
        sprites.kneepads.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(121, 181);
            })
        });
        sprites.allTattoos.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(103, 68);
            })
        });
        sprites.eyes.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(127, 80);
            })
        });
        sprites.smallCenterPlates.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(118, 140);
            })
        });
        sprites.smallStraps.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(118, 140);
            })
        });
        sprites.smallGems.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(118, 140)
            })
        });
        sprites.bloodObjects.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(94, 50)
            })
        });
        sprites.temporaryInjuryObjects.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(94, 50)
            })
        });
        sprites.temporaryTrophyObjects.map(function (x) {
            x.designs.map(function (y) {
                y.sprite.position.set(94, -10)
            })
        });

        function getObject(object, objects) {
            let objectIndex;
            // Don't add object if empty sprite
            if (object && object.designs[0].sprite === sprites.emptySprite) {
                objectIndex = -1
            }
            else {
                objectIndex = objects.indexOf(object)
            }
            return {
                object: objectIndex,
                colors: (object) ? object.designs.map(function (x) {
                    return x.defaultColor;
                }) : null
            }
        }

        function getGraphicJson(getAlternateAttires) {
            if (typeof(getAlternateAttires) === 'undefined') getAlternateAttires = true;

            let data = {
                accessory: getObject(addedAccessory, sprites.accessories),
                accessory2: getObject(addedAccessory2, sprites.accessories),
                accessory3: getObject(addedAccessory3, sprites.accessories),
                body: getObject(addedBody, sprites.bodies),
                bottoms: getObject(addedBottoms, sprites.bottoms),
                elbow: getObject(addedElbow, sprites.elbows),
                eyes: getObject(addedEyes, sprites.eyes),
                facepaint: getObject(addedFacepaint, sprites.facepaints),
                facialHair: getObject(addedFacialHair, sprites.facialHairs),
                hair: getObject(addedHair, sprites.hairs),
                knee: getObject(addedKneepad, sprites.kneepads),
                shoes: getObject(addedShoes, sprites.shoes),
                tattoo: getObject(addedTattoo, sprites.tattoos),
                torso: getObject(addedTorso, sprites.torsos)
            };

            if (addedTemporaryInjury) {
                data.temporaryInjury = getObject(addedTemporaryInjury, sprites.temporaryInjuryObjects)
            }
            if (addedTemporaryTrophy) {
                data.temporaryTrophy = getObject(addedTemporaryTrophy, sprites.temporaryTrophyObjects)
            }

            if (getAlternateAttires) {

                // If "A" attire not selected
                if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                    // Set graphic code to "A" attire
                    let baseAttireCode = graphicsParent.find('.attire-select-button:contains("A")').data('graphicJson');
                    data = JSON.parse(baseAttireCode);

                    // Save graphic data for selected attire
                    let selectedAttire = graphicsParent.find('.attire-select-button.selected');
                    $(selectedAttire).data('graphicJson', getGraphicJson(false));
                }

                // Get alternate attires if present and not same as base attire
                let alternateAttireCodes = [graphicsParent.find('.attire-select-button:contains("B")').data('graphicJson'),
                    graphicsParent.find('.attire-select-button:contains("C")').data('graphicJson')];
                let alternateAttireCodesFiltered = alternateAttireCodes.filter(function (jsonString) {
                    return jsonString && !objectEquals(JSON.parse(jsonString), data);
                });
                let alternateAttires = Array.from(alternateAttireCodesFiltered, function (jsonString) {
                    return JSON.parse(jsonString);
                });

                // Add alternate attires to graphic data
                data['alternate_attires'] = alternateAttires;
            }
            return JSON.stringify(data);
        }

        // Check for loaded data
        let data = jsonData;
        let addedBottoms;
        let addedBody;
        let addedShoes;
        let addedHair;
        let addedTorso;
        let addedElbow;
        let addedFacialHair;
        let addedAccessory;
        let addedAccessory2;
        let addedAccessory3;
        let addedKneepad;
        let addedFacepaint;
        let addedTattoo;
        let addedEyes;
        let addedTemporaryInjury;
        let addedTemporaryTrophy;
        let selectedAccessory;
        let accessoryNumbers = [1, 2, 3];
        let addedParts = {
            'body': addedBody, 'bottoms': addedBottoms, 'torso': addedTorso, 'hair': addedHair,
            'shoes': addedShoes, 'elbow': addedElbow, 'facialHair': addedFacialHair,
            'weapon': null, 'accessory': addedAccessory, 'accessory2': addedAccessory2, 'accessory3': addedAccessory3,
            'facepaint': addedFacepaint, 'knee': addedKneepad, 'tattoo': addedTattoo, 'eyes': addedEyes,
            'blood': null, 'temporaryInjury': null, 'temporaryTrophy': null
        };
        let allowChange;

        if (data || (match && match['special'])) {
            // Load character if data present or special segment
            loadCharacter(data);

            // Don't allow randomization after loading character
            allowChange = false;
        }
        else {
            // Add default character
            addedBottoms = sprites.bottoms[0];
            addedBody = sprites.bodies[0];
            addedShoes = sprites.shoes[0];
            addedHair = sprites.hairs[1];
            addedEyes = sprites.eyes[0];
            addedTorso = null;
            addedElbow = null;
            addedFacialHair = null;
            addedAccessory = null;
            addedAccessory2 = null;
            addedAccessory3 = null;
            addedKneepad = null;
            addedFacepaint = null;
            addedTattoo = null;

            // Add parts to stage, set colors and zIndex
            addedBody.designs.map(function (x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedBottoms.designs.map(function (x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedHair.designs.map(function (x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedShoes.designs.map(function (x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });
            addedEyes.designs.map(function (x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });

            // Allow randomization
            allowChange = true;
        }

        let originalGraphicData;
        if (jsonData) {
            originalGraphicData = JSON.stringify(jsonData[0]);
        }
        else {
            originalGraphicData = getGraphicJson(false);
        }

        renderer.render(stage);

        // Change style
        let x = 0;
        let scenarioFormSelector = $('#add-superstar, #create-gimmick-graphic-container, ' +
            '#change-appearance-graphic-container, .community-graphics-graphic-container, .scenario-editor-container, ' +
            '#change-staff-appearance-graphic-container');
        scenarioFormSelector.off().on('click', '.select-next, .select-previous', function () {

            allowChange = false;
            let $this = $(this);
            let accessoriesDuplicates = false;
            let accessoryNumberElement = $this.closest('.character-creator-controls').find('.accessory-number-button.selected');

            // Check for accessory sprite duplicates
            if (sprites.accessories.indexOf(selected) !== -1) {
                switch (accessoryNumberElement.text()) {
                    case '1':
                        selected = addedAccessory;
                        if (addedAccessory && (addedAccessory === addedAccessory2 || addedAccessory === addedAccessory3)) {
                            accessoriesDuplicates = true
                        }
                        break;
                    case '2':
                        selected = addedAccessory2;
                        if (addedAccessory2 && (addedAccessory2 === addedAccessory || addedAccessory2 === addedAccessory3)) {
                            accessoriesDuplicates = true
                        }
                        break;
                    case '3':
                        selected = addedAccessory3;
                        if (addedAccessory3 && (addedAccessory3 === addedAccessory || addedAccessory3 === addedAccessory2)) {
                            accessoriesDuplicates = true
                        }
                        break;
                    default:
                        selected = addedAccessory;
                        if (addedAccessory && (addedAccessory === addedAccessory2 || addedAccessory === addedAccessory3)) {
                            accessoriesDuplicates = true
                        }
                        break;
                }
            }

            // Replace existing part
            if (selections.indexOf(selected) !== -1) {
                // Don't replace if same sprite is in another accessory number
                if (!(accessoriesDuplicates)) {
                    selected.designs.map(function (x) {
                        stageObjects.removeChild(x.sprite);
                    })
                }
            }

            // Next and previous selection
            if ($this.hasClass('select-previous')) {
                x--
            }
            else {
                x++
            }

            // Stay within selections
            if (x === selections.length) {
                x = 0
            }
            if (x < 0) {
                x = selections.length - 1
            }

            // Select and display part (add to layer for z index sorting)
            selected = selections[x];
            if (selections.indexOf(selected) !== -1) {
                selected.designs.map(function (x) {
                    stageObjects.addChild(x.sprite);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.sprite.tint = x.defaultColor;
                })
            }

            renderer.render(stage);

            // Store selected part and alter positioning if needed
            if (sprites.hairs.indexOf(selected) !== -1) {
                addedHair = selected;
            }
            else if (sprites.bottoms.indexOf(selected) !== -1) {
                addedBottoms = selected;
            }
            else if (sprites.shoes.indexOf(selected) !== -1) {
                addedShoes = selected;
            }
            else if (sprites.torsos.indexOf(selected) !== -1) {
                addedTorso = selected;
            }
            else if (sprites.elbows.indexOf(selected) !== -1) {
                addedElbow = selected;
            }
            else if (sprites.facialHairs.indexOf(selected) !== -1) {
                addedFacialHair = selected;
            }
            else if (sprites.accessories.indexOf(selected) !== -1) {
                selectedAccessory = selected;
                // Save to accessory number
                switch (accessoryNumberElement.text()) {
                    case '1':
                        addedAccessory = selected;
                        break;
                    case '2':
                        addedAccessory2 = selected;
                        break;
                    case '3':
                        addedAccessory3 = selected;
                        break;
                    default:
                        addedAccessory = selected;
                }
            }
            else if (sprites.tattoos.indexOf(selected) !== -1) {
                addedTattoo = selected;
            }
            else if (sprites.facepaints.indexOf(selected) !== -1) {
                addedFacepaint = selected;
            }
            else if (sprites.kneepads.indexOf(selected) !== -1) {
                addedKneepad = selected;
            }
            else if (sprites.eyes.indexOf(selected) !== -1) {
                addedEyes = selected;
            }
            else if (sprites.bodies.indexOf(selected) !== -1) {
                addedBody = selected;
                addedBody.parentLayer = layer;
                addedBody.zIndex = -1;

                updateBodySprites();
            }

            // Update selection number
            $this.parent().find('.selection-number').text(x + 1);

            // Update positions of parts based on size
            updateDesigns(selected);

            if (selected === sprites.topObject41) {
                if ($('.buy-jow-shirt').length > 0) {
                    $('.buy-jow-shirt').show()
                }
                else {
                    el.parent().find('.preset-2').after(
                        '\n<button type="button" class="button retro-button gold-button-background ' +
                        'condensed remove-outline buy-jow-shirt no-select">Buy Shirt</button>'
                    )
                }
            }
            else {
                $('.buy-jow-shirt').hide()
            }
        });

        // Link to shirt
        scenarioFormSelector.on("click", ".buy-jow-shirt", function () {
            window.open("https://teespring.com/new-journey-of-wrestling");
        });

        // Select part to edit
        scenarioFormSelector.on("click", ".part-button", function () {

            if ($(this).hasClass('disabled')) {
                notie.alert({
                    type: 4, text: 'You cannot change Body, Eyes, Hair, Facial Hair or Tattoos for Alternate Attires'
                });
                return false;
            }

            // Hide share/import
            $(this).parent().siblings('.load-character-code-container').hide();
            $(this).parent().siblings('.share-character-code-container').hide();
            $(this).parent().siblings('.graphics-search-container').hide();
            $(this).parent().siblings('.character-creator-menu').find('.button').removeClass('selected');

            let $this = $(this);
            $(this).addClass('selected');
            $(this).parent().children().each(function () {
                if (!($(this).is($this))) {
                    $(this).removeClass('selected')
                }
            });
            selectedPart = $(this).text().trim().toLowerCase();
            let selectAccessoryElement = $this.siblings('.select-accessory-number');
            let characterCreatorElement = $this.closest('.character-creator-controls');

            let subCategories = [];

            // Reset accessory number selection
            characterCreatorElement.find('.select-accessory-number').html('');

            switch ($(this).text().trim()) {
                case 'Body':
                    selections = sprites.bodies;
                    if (addedBody) {
                        x = selections.indexOf(addedBody);
                        selected = addedBody;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
                case 'Bottoms':
                    selections = sprites.bottoms;
                    if (addedBottoms) {
                        x = selections.indexOf(addedBottoms);
                        selected = addedBottoms;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    subCategories = ['Tights', 'Trunks', 'Shorts', 'Feminine'];
                    break;
                case 'Torso':
                    selections = sprites.torsos;
                    if (addedTorso) {
                        x = selections.indexOf(addedTorso);
                        selected = addedTorso;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    subCategories = ['Shirt', 'Vest', 'Sports Bra', 'Feminine', 'Other'];
                    break;
                case 'Hair':
                    selections = sprites.hairs;
                    if (addedHair) {
                        x = selections.indexOf(addedHair);
                        selected = addedHair;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    subCategories = ['Short', 'Long', 'Feminine'];
                    break;
                case 'Shoes':
                    selections = sprites.shoes;
                    if (addedShoes) {
                        x = selections.indexOf(addedShoes);
                        selected = addedShoes;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    subCategories = ['Long', 'Short'];
                    break;
                case 'Elbow':
                    selections = sprites.elbows;
                    if (addedElbow) {
                        x = selections.indexOf(addedElbow);
                        selected = addedElbow;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
                case 'Facial Hair':
                    selections = sprites.facialHairs;
                    if (addedFacialHair) {
                        x = selections.indexOf(addedFacialHair);
                        selected = addedFacialHair;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
                case 'Accessory':
                    selections = sprites.accessories;
                    subCategories = ['Wrist Tape', 'Gloves', 'Glasses', 'Neck', 'Suit & Tie', 'Feminine', 'Weapons', 'Masks', 'Flags', 'Other'];

                    // Show accessory number selection
                    let html = '';
                    accessoryNumbers.forEach(function (accessoryNumber) {
                        html += '<button type="button" class="button retro-button condensed dark-grey-button-background remove-outline ' +
                            'accessory-number-button">' +
                            accessoryNumber + '</button>\n'
                    });
                    selectAccessoryElement.html(html);
                    selectAccessoryElement.find('.accessory-number-button').eq(0).trigger('click');

                    break;
                case 'Knee':
                    selections = sprites.kneepads;
                    if (addedKneepad) {
                        x = selections.indexOf(addedKneepad);
                        selected = addedKneepad;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
                case 'Facepaint':
                    selections = sprites.facepaints;
                    if (addedFacepaint) {
                        x = selections.indexOf(addedFacepaint);
                        selected = addedFacepaint;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
                case 'Tattoo':
                    selections = sprites.tattoos;
                    if (addedTattoo) {
                        x = selections.indexOf(addedTattoo);
                        selected = addedTattoo;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
                case 'Eyes':
                    selections = sprites.eyes;
                    if (addedEyes) {
                        x = selections.indexOf(addedEyes);
                        selected = addedEyes;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
            }
            addCharacterCreatorSubCategory(subCategories, characterCreatorElement);
        });

        // Select sub-category
        scenarioFormSelector.on("click", ".sub-category-button", function () {

            // Hide share/import
            $(this).parent().siblings('.load-character-code-container').hide();
            $(this).parent().siblings('.share-character-code-container').hide();
            $(this).parent().siblings('.graphics-search-container').hide();
            $(this).parent().siblings('.character-creator-menu').find('.button').removeClass('selected');

            // Select sub-category button
            let $this = $(this);
            $(this).addClass('selected');
            $(this).parent().children().each(function () {
                if (!($(this).is($this))) {
                    $(this).removeClass('selected')
                }
            });
            let accessoryNumber = $this.parent().siblings('.select-accessory-number').find('.accessory-number-button.selected').text();

            // Check for accessory sprite duplicates
            let accessoriesDuplicates = false;
            if (sprites.accessories.indexOf(selected) !== -1) {
                switch (accessoryNumber) {
                    case '1':
                        if (addedAccessory && (addedAccessory === addedAccessory2 || addedAccessory === addedAccessory3)) {
                            accessoriesDuplicates = true
                        }
                        selected = addedAccessory;
                        break;
                    case '2':
                        if (addedAccessory2 && (addedAccessory2 === addedAccessory || addedAccessory2 === addedAccessory3)) {
                            accessoriesDuplicates = true
                        }
                        selected = addedAccessory2;
                        break;
                    case '3':
                        if (addedAccessory3 && (addedAccessory3 === addedAccessory2 || addedAccessory3 === addedAccessory)) {
                            accessoriesDuplicates = true
                        }
                        selected = addedAccessory3;
                        break;
                    default:
                        if (addedAccessory && (addedAccessory === addedAccessory2 || addedAccessory === addedAccessory3)) {
                            accessoriesDuplicates = true
                        }
                        selected = addedAccessory;
                        break;
                }
            }

            // Remove existing part
            if (selections.indexOf(selected) !== -1) {
                if (!(accessoriesDuplicates)) {
                    selected.designs.map(function (x) {
                        stageObjects.removeChild(x.sprite);
                    })
                }
            }

            // Category name parsing
            let subCategoryName = $this.text().trim();
            let parentCategoryName = $this.parent().siblings('.selected').text().trim();
            selections = getSubCategorySelections(parentCategoryName, subCategoryName);

            // Select first part of sub-category
            x = 0;

            // Set selected part
            try {
                setSelectedPartForSubCategory(parentCategoryName, selections[x], accessoryNumber)
            } catch (e) {
                captureError(e)
            }

            $(this).closest('.select-part').siblings('.part-controls').find('.selection-number').text(x + 1);
            updateDesigns(selected);

            // Display part
            selected.designs.map(function (x) {
                stageObjects.addChild(x.sprite);
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
            });
            renderer.render(stage);

            allowChange = false;
        });

        // Select accessory number
        scenarioFormSelector.on("click", ".accessory-number-button", function () {

            // Hide share/import
            $(this).parent().siblings('.load-character-code-container').hide();
            $(this).parent().siblings('.share-character-code-container').hide();
            $(this).parent().siblings('.graphics-search-container').hide();
            $(this).parent().siblings('.character-creator-menu').find('.button').removeClass('selected');

            // Select this button
            let $this = $(this);
            $(this).addClass('selected');
            $(this).parent().children().each(function () {
                if (!($(this).is($this))) {
                    $(this).removeClass('selected')
                }
            });

            // Reset sub category buttons and selections
            $(this).parent().siblings('.select-sub-category').find('.sub-category-button').removeClass('selected');
            selections = sprites.accessories;

            // Load using accessory number
            let accessoryNumber = $this.text();
            switch (accessoryNumber) {
                case '1':
                    selectedAccessory = addedAccessory;
                    break;
                case '2':
                    selectedAccessory = addedAccessory2;
                    break;
                case '3':
                    selectedAccessory = addedAccessory3;
                    break;
                default:
                    selectedAccessory = addedAccessory;
            }

            if (selectedAccessory) {
                x = selections.indexOf(selectedAccessory);
                selected = selectedAccessory;
                $(this).closest('.select-part').siblings('.part-controls').find('.selection-number').text(x + 1);
                updateDesigns(selected);
            }
            else {
                x = -1;
                $(this).closest('.select-part').siblings('.part-controls').find('.selection-number').text(0);
                $(this).closest('.select-part').siblings('.part-controls').find('.select-design .button').hide();
            }
        });

        // Select design to recolor
        scenarioFormSelector.on('click', '.select-design .button', function () {
            let $this = $(this);
            $(this).addClass('selected');
            $this.parent().children().each(function () {
                if (!($(this).is($this))) {
                    $(this).removeClass('selected')
                }
            });

            // Update color selection
            let i = $this.parent().children().index($this);
            if (i >= 0) {
                let color = selected.designs[i].defaultColor.slice(2);
                $this.parent().parent().prev().find('.spectrum').spectrum('set', color);
            }
        });

        // Change color
        scenarioFormSelector.on('move.spectrum change', '.spectrum', function (e, tinycolor) {
            if (selected) {
                allowChange = false;
                let selectDesign = $(this).parent().siblings('.select-design-holder').children('.select-design');

                // Convert color to hexadecimal
                let colorString = tinycolor.toHexString();
                let color = '0x' + colorString.slice(1);
                // Find which design is selected
                let i;
                if (selectDesign.find('.selected:visible').length > 0) {
                    i = selectDesign.find('button').index(selectDesign.find('.selected'));
                } else {
                    i = 0
                }

                selected.designs[i].sprite.tint = color;
                // Change default color, saving selected color
                selected.designs[i].defaultColor = color;
                renderer.render(stage);
            }
        });

        // Save character
        scenarioFormSelector.on('click', '.share-character', function () {

            jsonData = getGraphicJson();

            // Show code and copy button
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).parent().siblings('.share-character-code-container').hide();
            }
            else {
                $(this).siblings().removeClass('selected');
                $(this).addClass('selected');
                $(this).parent().siblings('.share-character-code-container').show();
                $(this).parent().siblings('.share-character-code-container')
                    .children('.share-character-code-input').val(jsonData).text(jsonData).focus();
                $(this).parent().siblings('.load-character-code-container').hide();
                $(this).parent().siblings('.randomize-character-container').hide();
                $(this).parent().siblings('.graphics-search-container').hide();
            }
        });

        // Copy character code
        scenarioFormSelector.on('click', '.copy-character-code', function () {
            $(this).parent().siblings('.character-creator-menu').find('.share-character').trigger('click');
            copyToClipboard($(this).siblings('.share-character-code-input'));
        });

        // Import character
        scenarioFormSelector.on('click', '.import-character', function () {
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).parent().siblings('.load-character-code-container').hide();
            }
            else {
                $(this).siblings().removeClass('selected');
                $(this).addClass('selected');
                // Show input and load button
                $(this).parent().siblings('.load-character-code-container').show();
                $(this).parent().siblings('.load-character-code-container').find('.load-character-code-input').focus();
                $(this).parent().siblings('.share-character-code-container').hide();
                $(this).parent().siblings('.randomize-character-container').hide();
                $(this).parent().siblings('.graphics-search-container').hide();
            }
        });

        // Load character code
        scenarioFormSelector.on('click', '.load-character-code-button', function () {

            let data = $(this).siblings('.load-character-code-input').val();
            if (!data) {
                notie.alert({type: 3, text: 'Invalid character code', stay: false});
            }
            else {
                let communityGraphics = $(el).closest('.community-graphics-graphic-container').length > 0;

                // If loading community graphic, confirm if changes made
                if (communityGraphics) {
                    if (allowChange) {
                        loadCharacterCode(data, $(this), communityGraphics)
                    }
                    // Otherwise notie alert asking to confirm
                    else {
                        notie.confirm({
                            text: 'Are you sure?',
                            submitCallback: function () {
                                loadCharacterCode(data, $(this), communityGraphics);
                                allowChange = true;
                            }
                        });
                    }
                }
                else {
                    loadCharacterCode(data, $(this), communityGraphics);
                }
            }
        });

        function loadCharacterCode(data, button, communityGraphics) {
            try {

                let loadAlternateAttires = true;

                // Only load clothes for alternate attires, except when loading inside community graphics
                if (!communityGraphics) {
                    if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {

                        // Replace physical appearance parts
                        let keys = ['body', 'eyes', 'hair', 'facialHair', 'tattoo'];
                        let selectedAttire = graphicsParent.find('.attire-select-button.selected');
                        let baseAttireCode = JSON.parse($(selectedAttire).data('graphicJson'));
                        let currentAttireCode = JSON.parse(data);

                        // Go through each key, replacing with base attire value if this attire's value is same as base attire's value
                        keys.forEach(function (key) {
                            if (currentAttireCode[key] && JSON.stringify(currentAttireCode[key]) !== JSON.stringify(baseAttireCode[key])) {
                                currentAttireCode[key] = baseAttireCode[key];
                            }
                        });

                        data = JSON.stringify(currentAttireCode);
                        loadAlternateAttires = false;
                    }
                }

                // Delete temporary keys
                jsonData = JSON.parse(data);
                if (jsonData.temporaryInjury) {
                    delete jsonData.temporaryInjury;
                    data = JSON.stringify(jsonData)
                }
                if (jsonData.temporaryTrophy) {
                    delete jsonData.temporaryTrophy;
                    data = JSON.stringify(jsonData)
                }

                loadGraphicCode(data, loadAlternateAttires);
                button.parent().siblings('.character-creator-menu').find('.import-character').removeClass('selected');
                button.parent('.load-character-code-container').hide();
                if (!communityGraphics) {
                    notie.alert({type: 4, text: 'Character loaded!', stay: false})
                }
            }
            catch (e) {
                captureError(e)
                notie.alert({type: 3, text: 'Invalid character code', stay: false});
            }
        }

        function loadGraphicCode(data, loadAlternateAttires) {
            if (typeof(loadAlternateAttires) === 'undefined') loadAlternateAttires = false;

            let characterData = JSON.parse(data);
            loadCharacter([characterData]);
            updateBodySprites();

            if (loadAlternateAttires) {

                loadBaseAttire();

                // Load alternate attires
                let characterDataAlternateAttires = (characterData['alternate_attires']) ? characterData['alternate_attires'] : [];
                characterDataAlternateAttires.forEach(function (attire, i) {
                    attireButtons[i].data('graphicJson', JSON.stringify(attire));
                });

                // Load default attire in unused alternate attire buttons
                delete characterData['alternate_attires'];  // Remove alternate attires key for alternate attires
                let unusedButtons = attireButtons.slice(characterDataAlternateAttires.length);
                unusedButtons.forEach(function (attireButton) {
                    attireButton.data('graphicJson', JSON.stringify(characterData))
                });
            }
        }

        // Randomize character menu
        scenarioFormSelector.on('click', '.randomize-character', function () {

            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).parent().siblings('.randomize-character-container').hide();
            }
            else {
                $(this).siblings().removeClass('selected');
                $(this).addClass('selected');
                // Show input and load button
                $(this).parent().siblings('.randomize-character-container').show();
                $(this).parent().siblings('.share-character-code-container').hide();
                $(this).parent().siblings('.load-character-code-container').hide();
                $(this).parent().siblings('.graphics-search-container').hide();
            }
        });

        // Search community graphics button
        scenarioFormSelector.on('click', '.search-graphics', function () {

            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).parent().siblings('.graphics-search-container').hide();
            }
            else {
                $(this).siblings().removeClass('selected');
                $(this).addClass('selected');
                // Show input and load button
                $(this).parent().siblings('.share-character-code-container').hide();
                $(this).parent().siblings('.load-character-code-container').hide();
                $(this).parent().siblings('.randomize-character-container').hide();

                let graphicsSearchContainer = $(this).parent().siblings('.graphics-search-container');
                graphicsSearchContainer.show();
                graphicsSearchContainer.find('.graphics-search-input-name').val('').focus();
                graphicsSearchContainer.find('.graphics-search-results').hide();

                if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                    notie.alert({
                        type: 4,
                        text: 'Only clothes are imported for Alternate Attires. Select Attire "A" to load the full graphic.',
                        stay: false
                    });
                }
            }
        });

        // Search graphics
        scenarioFormSelector.on('click', '.graphics-search-button', function () {
            let parent = $(this).closest('.graphics-search-container');
            let searchTerm = parent.find('.graphics-search-input-name').val();
            // Validate
            if (searchTerm.length <= 0) {
                notie.alert({type: 3, text: "Enter a name to search for"});
                return false;
            }
            runTemplateSuperstarsEditorSearch(parent, searchTerm)
        });
        scenarioFormSelector.on('keypress', '.graphics-search-input-name', function(e){
            // Trigger search on enter key press
            if (e.which === 13) {
                $(this).parent().find('.graphics-search-button').click();
                e.preventDefault();
            }
        });

        // Recommend graphic
        scenarioFormSelector.on('click', '.recommend-community-graphic-button', function (e) {
            e.stopPropagation();
            let el = $(this);
            let uid = $(this).closest('.graphics-search-result-item').attr('data-uid');
            rateTemplateSuperstarRequest(el, uid);
        });

        // Sort graphic search results
        scenarioFormSelector.on('click', '.graphics-search-sort-results-button', function(){
            if (!$(this).hasClass('selected')) {
                $(this).siblings().removeClass('selected');
                $(this).addClass('selected');
            }
            let sortValue = $(this).text().trim().toLowerCase();
            let parent = $(this).closest('.graphics-search-container');
            let searchTerm = parent.find('.graphics-search-input-name').val();
            runTemplateSuperstarsEditorSearch(parent, searchTerm, null, sortValue);
        });

        // Next/previous page buttons
        scenarioFormSelector.on('click', '.graphics-next-page-button, ' +
            '.graphics-previous-page-button', function () {
            let page = $(this).data('page');
            let parent = $(this).closest('.graphics-search-container');
            let searchTerm = parent.find('.graphics-search-input-name').val();
            let sortValue = parent.find('.graphics-search-sort-results-button.selected').text().trim().toLowerCase();
            runTemplateSuperstarsEditorSearch(parent, searchTerm, page, sortValue);
        });

        // Load graphic upon clicking on search result
        scenarioFormSelector.on('click', '.graphics-search-result-item', function(){
            let parent = $(this).closest('.graphics-search-container');
            $(this).siblings().removeClass('selected');
            $(this).addClass('selected');
            let graphicCode = $(this).attr('data-graphic');
            parent.siblings('.load-character-code-container').find('.load-character-code-input').val(graphicCode);
            parent.siblings('.load-character-code-container').find('.load-character-code-button').trigger('click');
        });

        // Randomize character button
        scenarioFormSelector.on('click', '.randomize-character-button', function () {

            let randomizeOption = $(this).text().trim();
            let onlyClothes = (randomizeOption === 'Clothes');

            if (!onlyClothes) {
                if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                    notie.alert({
                        type: 3,
                        text: 'You cannot randomize body on Alternate Attires. Select Attire "A" to randomize body.',
                        stay: false
                    });
                    return false;
                }
            }

            function randomizeGraphic() {

                // Reset stage
                while (stageObjects.children[0]) {
                    stageObjects.removeChild(stageObjects.children[0]);
                }
                while (stageLayers.children[0]) {
                    stageLayers.removeChild(stageLayers.children[0]);
                }

                let color;

                // Select body type if onlyClothes not selected
                if (!onlyClothes) {
                    if (randomizeOption === 'Masculine') {
                        let bodiesWeights = [70, 0, 0, 0, 0, 30];
                        addedBody = pickUsingWeights(sprites.bodies, bodiesWeights);
                    }
                    else if (randomizeOption === 'Feminine') {
                        let bodiesWeights = [0, 0, 0, 70, 30, 0];
                        addedBody = pickUsingWeights(sprites.bodies, bodiesWeights);
                    }
                    else {
                        let bodiesWeights = [40, 10, 10, 20, 10, 10];
                        addedBody = pickUsingWeights(sprites.bodies, bodiesWeights);
                    }
                }

                // Get style
                let style = (addedBody === sprites.bodyObjectShe || addedBody === sprites.bodyObjectSheAbs) ? 'feminine' : 'masculine';

                // Style neutral parts
                addedEyes = sprites.eyes[0];
                addedShoes = sprites.shoes[getRandomInt(0, sprites.shoes.length - 1)];
                addedElbow = null;
                addedKneepad = null;
                addedFacepaint = null;
                addedTattoo = null;

                // Optional style-neutral parts
                if (getRandomInt(0, 100) <= 5) {
                    addedElbow = sprites.elbows[getRandomInt(0, sprites.elbows.length - 1)];
                }
                if (getRandomInt(0, 100) <= 5) {
                    addedKneepad = sprites.kneepads[getRandomInt(0, sprites.kneepads.length - 1)];
                }
                if (getRandomInt(0, 100) <= 4) {
                    addedFacepaint = sprites.facepaints[getRandomInt(0, sprites.facepaints.length - 1)];
                }
                // Don't select new tattoo if onlyClothes selected
                if (!onlyClothes && getRandomInt(0, 100) <= 10) {
                    addedTattoo = sprites.tattoos[getRandomInt(0, sprites.tattoos.length - 1)];
                }

                // Style specific parts
                addedTorso = null;
                addedAccessory = null;
                addedAccessory2 = null;
                addedAccessory3 = null;

                if (style === 'masculine') {

                    // Larger chance to select from masculine designs
                    let bottomsChoices = (getRandomInt(0, 100) <= 99) ?
                        sprites.tights.concat(sprites.trunks, sprites.shorts) : sprites.feminineBottoms;
                    let hairChoices = (getRandomInt(0, 100) <= 99) ?
                        sprites.shortHair.concat(sprites.longHair) : sprites.feminineHair;

                    addedBottoms = getRandomChoice(bottomsChoices);

                    // Don't select new hair and facial hair if onlyClothes selected
                    if (!onlyClothes) {
                        addedHair = getRandomChoice(hairChoices);
                        addedFacialHair = null;
                        if (getRandomInt(0, 100) <= 20) {
                            addedFacialHair = getRandomChoice(sprites.facialHairs);
                        }
                    }

                    if (getRandomInt(0, 100) <= 25) {
                        let torsoChoices = (getRandomInt(0, 100) <= 99) ?
                            sprites.shirtTops.concat(sprites.vestTops, sprites.otherTops) :
                            sprites.sportsBraTops.concat(sprites.feminineTops);
                        addedTorso = getRandomChoice(torsoChoices);
                    }

                    let accessoryChoices = (getRandomInt(0, 100) <= 99) ?
                        sprites.glovesAccessories.concat(sprites.wristTapeAccessories, sprites.suitAndTieAccessories,
                            sprites.neckAccessories, sprites.otherAccessories, sprites.glassesAccessories, sprites.masksAccessories) :
                        sprites.feminineAccessories;

                    if (getRandomInt(0, 100) <= 3) {
                        addedAccessory = getRandomChoice(accessoryChoices);
                    }
                    if (getRandomInt(0, 100) <= 5) {
                        addedAccessory2 = getRandomChoice(accessoryChoices);
                    }
                    if (getRandomInt(0, 100) <= 5) {
                        addedAccessory3 = getRandomChoice(accessoryChoices);
                    }
                }
                else if (style === 'feminine') {
                    // Larger chance to select from masculine designs
                    let bottomsChoices = (getRandomInt(0, 100) <= 5) ?
                        sprites.tights.concat(sprites.trunks, sprites.shorts) : sprites.feminineBottoms;
                    let hairChoices = (getRandomInt(0, 100) <= 5) ?
                        sprites.shortHair.concat(sprites.longHair) : sprites.feminineHair;
                    let torsoChoices = (getRandomInt(0, 100) <= 5) ?
                        sprites.shirtTops.concat(sprites.vestTops, sprites.otherTops) :
                        sprites.sportsBraTops.concat(sprites.feminineTops);

                    // Remove empty sprite from tops
                    torsoChoices = torsoChoices.filter(function (element) {
                        return element !== sprites.emptyTopObject;
                    });

                    addedBottoms = getRandomChoice(bottomsChoices);
                    addedTorso = getRandomChoice(torsoChoices);

                    // Don't select new hair and facial hair if onlyClothes selected
                    if (!onlyClothes) {
                        addedHair = getRandomChoice(hairChoices);
                        addedFacialHair = null;
                        if (getRandomInt(0, 100) <= 0) {
                            addedFacialHair = getRandomChoice(sprites.facialHairs);
                        }
                    }

                    let accessoryChoices = (getRandomInt(0, 100) <= 80) ? sprites.feminineAccessories :
                        sprites.glovesAccessories.concat(sprites.glassesAccessories, sprites.wristTapeAccessories,
                            sprites.neckAccessories, sprites.suitAndTieAccessories, sprites.otherAccessories,
                            sprites.masksAccessories);
                    if (getRandomInt(0, 100) <= 3) {
                        addedAccessory = getRandomChoice(accessoryChoices);
                    }
                    if (getRandomInt(0, 100) <= 5) {
                        addedAccessory2 = getRandomChoice(accessoryChoices);
                    }
                    if (getRandomInt(0, 100) <= 5) {
                        addedAccessory3 = getRandomChoice(accessoryChoices);
                    }
                }

                // Add parts to stage

                // * Appearance parts, don't change color if onlyClothes selected *

                // Body
                addedBody.designs.map(function (x) {
                    if (!onlyClothes) {
                        let colors = ["#FFE4CB", "#F4D7BC", "#FFD9B6", "#FFD4AB", "#F2D2A5", "#DFB58D", "#CAA684", "#7A6353"];
                        if (getRandomInt(0, 100) <= 99) {
                            // Get color from skin tone palette
                            color = '0x' + colors[getRandomInt(0, colors.length - 1)].slice(1);
                        }
                        else {
                            // Get a random color
                            color = '0x' + getRandomColor().slice(1);
                        }
                        x.defaultColor = color;
                        x.sprite.tint = color;
                    }
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    stageObjects.addChild(x.sprite);
                });
                // Hair
                let hairColor;
                addedHair.designs.map(function (x) {
                    if (!onlyClothes) {
                        if (hairColor) {
                            // Get a new color, otherwise use existing color
                            if (getRandomInt(0, 100) <= 5) {
                                hairColor = getHairColor();
                            }
                        }
                        else {
                            hairColor = getHairColor();
                        }
                        x.defaultColor = hairColor;
                        x.sprite.tint = hairColor;
                    }
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    stageObjects.addChild(x.sprite);
                });
                // Facial Hair
                if (addedFacialHair) {
                    addedFacialHair.designs.map(function (x) {
                        if (!onlyClothes) {
                            // Same color as hair
                            x.defaultColor = hairColor;
                            x.sprite.tint = hairColor;
                        }
                        x.sprite.parentLayer = layer;
                        x.sprite.zIndex = x.zIndex;
                        stageObjects.addChild(x.sprite);
                    });
                }
                // Eyes
                addedEyes.designs.map(function (x) {
                    if (!onlyClothes) {
                        if (getRandomInt(0, 100) <= 99) {
                            color = '0x000000';
                        }
                        else {
                            // Get a random color
                            color = '0x' + getRandomColor().slice(1);
                        }
                        x.defaultColor = color;
                        x.sprite.tint = color;
                    }
                    else {
                        x.defaultColor = '0x000000';
                        x.sprite.tint = '0x000000';
                    }
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    stageObjects.addChild(x.sprite);
                });

                // * Clothes parts *

                // Bottoms
                let bottomsColor;
                addedBottoms.designs.map(function (x) {
                    if (!bottomsColor) {
                        bottomsColor = '0x' + getRandomColor().slice(1);
                    }
                    else {
                        if (getRandomInt(0, 100) <= 10) {
                            bottomsColor = '0x' + getRandomColor().slice(1);
                        }
                    }
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = bottomsColor;
                    x.sprite.tint = bottomsColor;
                    stageObjects.addChild(x.sprite);
                });

                // Shoes
                let shoeColor;
                addedShoes.designs.map(function (x) {
                    shoeColor = '0x1E1E1E';
                    if (getRandomInt(0, 100) <= 5) {
                        shoeColor = '0x' + getRandomColor().slice(1);
                    }
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = shoeColor;
                    x.sprite.tint = shoeColor;
                    stageObjects.addChild(x.sprite);
                });

                // Torso
                if (addedTorso) {
                    let torsoColor;
                    addedTorso.designs.map(function (x) {
                        if (!torsoColor) {
                            torsoColor = '0x' + getRandomColor().slice(1);
                        }
                        else {
                            if (getRandomInt(0, 100) <= 10) {
                                torsoColor = '0x' + getRandomColor().slice(1);
                            }
                        }
                        x.sprite.parentLayer = layer;
                        x.sprite.zIndex = x.zIndex;
                        x.defaultColor = torsoColor;
                        x.sprite.tint = torsoColor;
                        stageObjects.addChild(x.sprite);
                    });
                }

                // Elbow pads
                if (addedElbow) {
                    addedElbow.designs.map(function (x, i) {
                        // Same color as shoes for first layer
                        if (i > 0) {
                            color = '0x' + getRandomColor().slice(1);
                        }
                        else {
                            color = shoeColor
                        }
                        x.sprite.parentLayer = layer;
                        x.sprite.zIndex = x.zIndex;
                        x.defaultColor = color;
                        x.sprite.tint = color;
                        stageObjects.addChild(x.sprite);
                    });
                }

                // Accessory
                if (addedAccessory) {
                    addedAccessory.designs.map(function (x) {
                        color = '0x' + getRandomColor().slice(1);
                        x.sprite.parentLayer = layer;
                        x.sprite.zIndex = x.zIndex;
                        x.defaultColor = color;
                        x.sprite.tint = color;
                        stageObjects.addChild(x.sprite);
                    });
                }
                if (addedAccessory2) {
                    addedAccessory2.designs.map(function (x) {
                        color = '0x' + getRandomColor().slice(1);
                        x.sprite.parentLayer = layer;
                        x.sprite.zIndex = x.zIndex;
                        x.defaultColor = color;
                        x.sprite.tint = color;
                        stageObjects.addChild(x.sprite);
                    });
                }
                if (addedAccessory3) {
                    addedAccessory3.designs.map(function (x) {
                        color = '0x' + getRandomColor().slice(1);
                        x.sprite.parentLayer = layer;
                        x.sprite.zIndex = x.zIndex;
                        x.defaultColor = color;
                        x.sprite.tint = color;
                        stageObjects.addChild(x.sprite);
                    });
                }

                // Knee pads
                if (addedKneepad) {
                    addedKneepad.designs.map(function (x, i) {
                        // Same color as shoes for first layer
                        if (i > 0) {
                            color = '0x' + getRandomColor().slice(1);
                        }
                        else {
                            color = shoeColor
                        }
                        x.sprite.parentLayer = layer;
                        x.sprite.zIndex = x.zIndex;
                        x.defaultColor = color;
                        x.sprite.tint = color;
                        stageObjects.addChild(x.sprite);
                    });
                }

                // Facepaint
                if (addedFacepaint) {
                    addedFacepaint.designs.map(function (x) {
                        color = '0x' + getRandomColor().slice(1);
                        x.sprite.parentLayer = layer;
                        x.sprite.zIndex = x.zIndex;
                        x.defaultColor = color;
                        x.sprite.tint = color;
                        stageObjects.addChild(x.sprite);
                    });
                }

                // Tattoo
                if (addedTattoo) {
                    addedTattoo.designs.map(function (x) {
                        if (!onlyClothes) {
                            color = '0x585858';
                            if (getRandomInt(0, 100) <= 5) {
                                color = '0x' + getRandomColor().slice(1);
                            }
                            x.defaultColor = color;
                            x.sprite.tint = color;
                        }
                        x.sprite.parentLayer = layer;
                        x.sprite.zIndex = x.zIndex;
                        stageObjects.addChild(x.sprite);
                    });
                }

                updateBodySprites();

                // If body changed, add data to attire buttons
                if (!onlyClothes) {
                    attireButtons.forEach(function (attireButton) {
                        attireButton.data('graphicJson', getGraphicJson(false))
                    });
                }

                // If base attire selected, load 'Body' part button, otherwise load 'Torso'
                if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                    el.find('.part-button:contains("Torso")').trigger('click');
                }
                else {
                    el.find('.part-button:contains("Body")').trigger('click');
                }

                $('.randomize-character').addClass('selected');
            }

            // Randomize instantly if no parts changed
            if (allowChange) {
                randomizeGraphic()
            }
            // Otherwise notie alert asking to confirm
            else {
                notie.confirm({
                    text: 'Are you sure?',
                    submitCallback: function () {
                        randomizeGraphic();
                        allowChange = true;
                    }
                });
            }

        });

        // Masculine preset
        scenarioFormSelector.on('click', '.preset-1', function () {

            if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                notie.alert({type: 3,
                    text: 'You cannot load presets on Alternate Attires. Select Attire "A" to load presets.', stay: false});
                return false;
            }

            function changeGraphic() {
                // Reset stage
                while (stageObjects.children[0]) {
                    stageObjects.removeChild(stageObjects.children[0]);
                }
                while (stageLayers.children[0]) {
                    stageLayers.removeChild(stageLayers.children[0]);
                }

                // Select parts
                addedBottoms = sprites.tightsObject0;
                addedBody = sprites.bodyObjectHe;
                addedShoes = sprites.shoesObject0;
                addedHair = sprites.hairObject1;
                addedTorso = null;
                addedElbow = null;
                addedFacialHair = null;
                addedAccessory = null;
                addedAccessory2 = null;
                addedAccessory3 = null;
                addedKneepad = null;
                addedFacepaint = null;
                addedTattoo = null;
                addedEyes = sprites.eyes[0];

                // Add parts to stage
                addSpriteToStage(addedBody, '0xF7D1B9', stageObjects, layer);
                addSpriteToStage(addedBottoms, '0x333333', stageObjects, layer);
                addSpriteToStage(addedHair, '0x71645F', stageObjects, layer);
                addSpriteToStage(addedShoes, '0x1B1B1B', stageObjects, layer);
                addSpriteToStage(addedEyes, '0x000000', stageObjects, layer);

                updateBodySprites();
                el.find('.button:contains("Body")').trigger('click');
                notie.alert({type: 4, text: 'Preset loaded', stay: false});

                // Add data to attire buttons
                attireButtons.forEach(function (attireButton) {
                    attireButton.data('graphicJson', getGraphicJson(false))
                });
            }

            if (allowChange) {
                changeGraphic();
            }
            else {
                notie.confirm({
                    text: 'Are you sure?',
                    submitCallback: function () {
                        changeGraphic();
                        allowChange = true;
                    }
                });
            }

        });

        // Feminine preset
        scenarioFormSelector.on('click', '.preset-2', function () {

            if (graphicsParent.find('.attire-select-button.selected:contains("A")').length <= 0) {
                notie.alert({type: 3,
                    text: 'You cannot load presets on Alternate Attires. Select Attire "A" to load presets.', stay: false});
                return false;
            }

            function changeGraphic() {
                // Reset stage
                while (stageObjects.children[0]) {
                    stageObjects.removeChild(stageObjects.children[0]);
                }
                while (stageLayers.children[0]) {
                    stageLayers.removeChild(stageLayers.children[0]);
                }

                // Select parts
                addedBottoms = sprites.femaleBottomObject7;
                addedBody = sprites.bodyObjectShe;
                addedShoes = sprites.shoesObject0;
                addedHair = sprites.hairs[36];
                addedTorso = sprites.sportsBraObjectBasic;
                addedElbow = null;
                addedFacialHair = null;
                addedAccessory = null;
                addedAccessory2 = null;
                addedAccessory3 = null;
                addedKneepad = null;
                addedFacepaint = null;
                addedTattoo = null;
                addedEyes = sprites.eyes[0];

                // Add parts to stage
                addSpriteToStage(addedBody, '0xF7D1B9', stageObjects, layer);
                addSpriteToStage(addedBottoms, '0x444444', stageObjects, layer);
                addSpriteToStage(addedTorso, '0x444444', stageObjects, layer);
                addSpriteToStage(addedHair, '0xB59B82', stageObjects, layer);
                addSpriteToStage(addedShoes, '0x1B1B1B', stageObjects, layer);
                addSpriteToStage(addedEyes, '0x000000', stageObjects, layer);

                updateBodySprites();
                el.find('.button:contains("Body")').trigger('click');
                notie.alert({type: 4, text: 'Preset loaded', stay: false});

                // Add data to attire buttons
                attireButtons.forEach(function (attireButton) {
                    attireButton.data('graphicJson', getGraphicJson(false))
                });
            }

            if (allowChange) {
                changeGraphic();
            }
            else {
                notie.confirm({
                    text: 'Are you sure?',
                    submitCallback: function () {
                        changeGraphic();
                        allowChange = true;
                    }
                });
            }

        });

        // Attire select
        scenarioFormSelector.on('click', '.attire-select-button', function () {

            // Save selected attire
            let selectedAttire = graphicsParent.find('.attire-select-button.selected');
            $(selectedAttire).data('graphicJson', getGraphicJson(false));

            // If alternate attire selected, check for body/eyes/hair/facial hair/tattoos change
            let $this = $(this);
            if ($this.text().trim() !== "A") {
                let keys = ['body', 'eyes', 'hair', 'facialHair', 'tattoo'];

                let baseAttireCode = JSON.parse($(selectedAttire).data('graphicJson'));
                let currentAttireCode = JSON.parse($this.data('graphicJson'));
                if (!currentAttireCode) {
                    currentAttireCode = JSON.parse(originalGraphicData);
                }

                // Go through each key, replacing with base attire value if this attire's value is same as base attire's value
                keys.forEach(function (key) {
                    if (currentAttireCode[key] && JSON.stringify(currentAttireCode[key]) !== JSON.stringify(baseAttireCode[key])) {
                        currentAttireCode[key] = baseAttireCode[key];
                        $this.data('graphicJson', JSON.stringify(currentAttireCode));
                    }
                });
            }

            // Select this button
            graphicsParent.find('.attire-select-button').removeClass('selected');
            $(this).addClass('selected');

            // Disable body, eyes, hair and facial hair part buttons, community graphics search, remove attire button
            // if not base (A) attire
            let parent = $(this).closest('.character-creator-controls');
            parent.find('.part-button.disabled').removeClass('disabled');
            $('.remove-attire-button').hide();
            if ($(this).text().trim() !== 'A') {
                parent.find('.part-button:contains("Body")').addClass('disabled');
                parent.find('.part-button:contains("Eyes")').addClass('disabled');
                parent.find('.part-button:contains("Hair")').addClass('disabled');
                parent.find('.part-button:contains("Facial Hair")').addClass('disabled');
                parent.find('.part-button:contains("Tattoo")').addClass('disabled');
                // Select Torso button if disabled button selected previously
                if (parent.find('.part-button.selected').hasClass('disabled')) {
                    el.find('.part-button:contains("Torso")').trigger('click')
                }
                $('.remove-attire-button').show();
            }

            // Load this attire
            let attireJsonData = $(this).data('graphicJson');
            if (attireJsonData) {
                loadGraphicCode(attireJsonData)
            }
            else {
                // Load default graphic if no attire present
                loadGraphicCode(originalGraphicData);
            }
        });

        // Change attire
        $('#roster-member-details, #superstar_info').off('click', '.attire-select-button');
        $('#roster-member-details, #superstar_info').on('click', '.attire-select-button', function () {

            // Load this attire
            let attireJsonData = $(this).data('graphicJson');
            if (!attireJsonData) {
                notie.alert({
                    type: 3, text: 'Attire not present'
                });
                return false;
            }
            loadGraphicCode(attireJsonData);

            // Select this button
            graphicsParent.find('.attire-select-button').removeClass('selected');
            $(this).addClass('selected');
        });

        // Remove attire
        $(scenarioFormSelector).on('click', '.remove-attire-button', function () {

            // Replace data from this attire button with "A" attire
            let baseAttireCode = graphicsParent.find('.attire-select-button:contains("A")').data('graphicJson');
            let attireButton = graphicsParent.find('.attire-select-button.selected');
            attireButton.data('graphicJson', baseAttireCode);
            attireButton.removeClass('selected');

            // Select "A" attire
            graphicsParent.find('.attire-select-button:contains("A")').trigger('click');

            notie.alert({type: 4, text: 'Alternate attire removed', stay: false});
        });

        // Select body button initially
        el.find('.button:contains("Body")').trigger('click');

        // Update parts positioning
        function updateBodySprites() {

            // Change parts to female
            if (addedBody === sprites.bodyObjectShe || addedBody === sprites.bodyObjectSheAbs) {

                // Replace current part
                if (addedTattoo) {

                    // Check if female part available
                    if (addedTattoo.femaleObject) {

                        // Remove male part
                        addedTattoo.designs.map(function (x) {
                            stageObjects.removeChild(x.sprite);
                        });

                        // Add female part
                        addedTattoo = addedTattoo.femaleObject;

                        // Display female part
                        addedTattoo.designs.map(function (x) {
                            stageObjects.addChild(x.sprite);
                            x.sprite.parentLayer = layer;
                            x.sprite.zIndex = x.zIndex;
                            x.sprite.tint = x.defaultColor;
                        });
                        renderer.render(stage);
                    }
                }
                if (addedFacepaint) {

                    // Check if female part available
                    if (addedFacepaint.femaleObject) {

                        // Remove male part
                        addedFacepaint.designs.map(function (x) {
                            stageObjects.removeChild(x.sprite);
                        });

                        // Add female part
                        addedFacepaint = addedFacepaint.femaleObject;

                        // Display  female part
                        addedFacepaint.designs.map(function (x) {
                            stageObjects.addChild(x.sprite);
                            x.sprite.parentLayer = layer;
                            x.sprite.zIndex = x.zIndex;
                            x.sprite.tint = x.defaultColor;
                        });
                        renderer.render(stage);
                    }
                }

                // Replace sprite list with female parts
                sprites.tattoos = sprites.feminineTattoos;
                sprites.facepaints = sprites.feminineFacepaints;
            }

            // Change parts to male
            else {

                // Replace current part
                if (addedTattoo) {

                    if (addedTattoo.maleObject) {

                        // Remove female part
                        addedTattoo.designs.map(function (x) {
                            stageObjects.removeChild(x.sprite);
                        });

                        // Add male part
                        addedTattoo = addedTattoo.maleObject;

                        // Display male part
                        addedTattoo.designs.map(function (x) {
                            stageObjects.addChild(x.sprite);
                            x.sprite.parentLayer = layer;
                            x.sprite.zIndex = x.zIndex;
                            x.sprite.tint = x.defaultColor;
                        });
                        renderer.render(stage);
                    }
                }
                if (addedFacepaint) {

                    if (addedFacepaint.maleObject) {

                        // Remove female part
                        addedFacepaint.designs.map(function (x) {
                            stageObjects.removeChild(x.sprite);
                        });

                        // Add male part
                        addedFacepaint = addedFacepaint.maleObject;

                        // Display male part
                        addedFacepaint.designs.map(function (x) {
                            stageObjects.addChild(x.sprite);
                            x.sprite.parentLayer = layer;
                            x.sprite.zIndex = x.zIndex;
                            x.sprite.tint = x.defaultColor;
                        });
                        renderer.render(stage);
                    }
                }

                // Replace sprite list with male parts
                sprites.tattoos = sprites.masculineTattoos;
                sprites.facepaints = sprites.masculineFacepaints;
            }

            renderer.render(stage);
        }

        // Load character
        function loadCharacter(data) {

            // Reset stage
            while (stageObjects.children[0]) {
                stageObjects.removeChild(stageObjects.children[0]);
            }
            while (stageLayers.children[0]) {
                stageLayers.removeChild(stageLayers.children[0]);
            }

            // Background
            if (characterBackgroundImage) {
                let background = PIXI.Sprite.fromImage(characterBackgroundImage);
                background.zIndex = -100;
                stageBackground.addChild(background);
            }

            // Get tag team size and divide canvas
            let teamLayers;
            let characterContainer;
            if (data) {
                let tagTeamSize;

                // Remove clothes for 'Love Making' segment action
                let removeClothes = (match && match['special'] && match['name'] === 'Love Making' && segmentAction);

                if (match) {
                    // Get tag team size
                    if (match['type'] === 'singles') {
                        tagTeamSize = 1;
                    } else {
                        tagTeamSize = 2;
                    }
                    if (match['segmentType'] === 'segment') {
                        tagTeamSize = 1
                    }
                    if (match['largerTag']) {
                        tagTeamSize = parseInt(match['largerTag']);
                    }
                } else {
                    tagTeamSize = 1;
                }

                // Get teams without managers
                let teams;
                let nonManagerData = data.filter(function (obj) {
                    return !obj['isManager'];
                });
                // If handicap match, get two teams using handicap size
                if (match && match['handicapSize']) {
                    let teamA = nonManagerData.slice(0, match['handicapSize'][0]);
                    let teamB = nonManagerData.slice(match['handicapSize'][0]);
                    teams = [teamA, teamB];
                }
                // Otherwise divide superstars into teams
                else {
                    teams = chunk(nonManagerData, tagTeamSize);
                }

                // Add managers to end of team
                teams.forEach(function (team, teamIndex) {
                    let teamManagers = [];
                    team.forEach(function (teamMember) {
                        let teamMemberManager = data.filter(function (obj) {
                            return obj['superstarUid'] && obj['superstarUid'] === teamMember['uid'];
                        })[0];
                        if (teamMemberManager) {
                            teamManagers.push(teamMemberManager);
                        }
                    });
                    if (teamIndex === 0 && teams.length > 1) {
                        // Add to start of team if first team (so managers appear on the left for them)
                        teamManagers.forEach(function(teamManager) {
                           team.unshift(teamManager)
                        });
                    } else {
                        teamManagers.forEach(function(teamManager) {
                           team.push(teamManager)
                        });
                    }
                });

                // Flatten teams to get graphics data, as order of graphics might have changed
                data = [].concat.apply([], teams);

                // Get rows
                let rows;
                let division;
                if (match) {
                    // Divide canvas for positioning (into rows for large number of superstars)
                    if (data.length > 10 && match['type'] === 'singles') {
                        rows = chunk(data, getEqualChunkSize(data.length));
                        division = renderer.width / (rows[0].length + 1);
                    } else if (data.length > 13 && match['type'] === 'tag') {
                        rows = chunk(data, getEqualChunkSize(data.length));
                        division = renderer.width / (rows[0].length + 1);
                    } else {
                        division = renderer.width / (data.length + 1);
                        rows = [data];
                    }
                }
                else {
                    division = renderer.width / (data.length + 1);
                    rows = [data];
                }
                division = Math.round(division);

                teamLayers = [];

                teams.forEach(function (team) {
                    let teamLayer = new PIXI.display.Layer();
                    stageLayers.addChild(teamLayer);
                    teamLayer.parentLayer = layer;
                    teamLayers.push(teamLayer);

                    // Sort faction graphics by characterLayer zIndex
                    if (match && match['factionGraphic']) {
                        teamLayer.group.enableSort = true;
                    }
                    // Sort managed superstar team by zIndex
                    team.forEach(function(teamMember) {
                        if (teamMember['isManager']) {
                            teamLayer.group.enableSort = true;
                            return;
                        }
                    });
                });

                rows.forEach(function (data, rowIndex) {

                    // Get division for row if more than 1 row
                    if (rowIndex > 0) {
                        division = renderer.width / (rows[rowIndex].length + 1);
                    }

                    data.forEach(function (characterData, i) {

                        let teamIndex = null;
                        // Go through teams, if indexOf(characterData) exists, get index of parent team
                        teams.map(function (y) {
                            if (y.indexOf(characterData) > -1) {
                                teamIndex = teams.indexOf(y);
                            }
                        });

                        characterContainer = new PIXI.Container();

                        let characterIndex = null;
                        // Get index of team member
                        teams.map(function (x) {
                            if (x.indexOf(characterData) > -1) {
                                characterIndex = x.indexOf(characterData);
                            }
                        });

                        let characterLayer = new PIXI.display.Layer();
                        characterLayer.group.enableSort = true;
                        teamLayers[teamIndex].addChild(characterLayer);

                        if (match && match['factionGraphic']) {
                            // Set zIndex for characterLayer, zIndex decreases after median
                            let medianIndex = Math.floor((teams[teamIndex].length + 1) / 2) - 1;
                            if (i > medianIndex) {
                                characterLayer.zIndex = medianIndex - (i - medianIndex);
                            } else {
                                characterLayer.zIndex = i;
                            }
                        }

                        // Add zIndex for manager, moving behind superstars
                        if (characterData['isManager']) {
                            if (teamIndex === 0) {
                                characterLayer.zIndex = characterIndex - teams[teamIndex].length;
                            }
                            else {
                                characterLayer.zIndex = -1 * characterIndex;
                            }
                        }

                        // Make manager slightly opaque
                        if (characterData['isManager']) {
                            let filter = new PIXI.filters.AlphaFilter();
                            filter.alpha = 0.7;
                            characterLayer.filters = [filter];
                        }

                        // Add character parts
                        let body = parts['body'][characterData['body']['object']];

                        Object.keys(addedParts).forEach(function (key) {

                            // Remove clothes
                            if (removeClothes) {
                                let bodyParts = ['body', 'hair', 'facialHair', 'tattoo', 'eyes'];
                                if (bodyParts.indexOf(key) < 0) {
                                    return
                                }
                            }

                            // Add referee shirt for referee
                            if (key === 'torso' && characterData['isReferee']) {
                                characterData[key] = {"object": 81, "colors": ["0x2D2D2D", "0xF0F0F0"]}
                            }

                            // Add weapon
                            if (key === 'weapon' && characterData['addWeaponGraphic']) {
                                // Don't add weapons for everyone if high number of superstars
                                if (data.length <= 6 || getRandomInt(0, 100) <= 50 || i === 1) {
                                    characterData[key] = selectGimmickMatchWeaponObject(characterData['uid'] + match['uid'])
                                }
                            }

                            // Get object by part key
                            let partData = characterData[key];
                            if (partData && partData['object'] >= 0) {
                                let objectIndex = characterData[key]['object'];
                                let item = parts[key][objectIndex]; // get object
                                let newItem = parts[key][objectIndex]; // duplicate object

                                // Remove held accessory if weapon graphic added
                                let heldAccessories = parts['weapon'].concat([sprites.accessoryObject23, sprites.accessoryObject24,
                                    sprites.accessoryObject50], sprites.flags);
                                if (['accessory', 'accessory2', 'accessory3'].indexOf(key) >= 0 && characterData['weapon']) {
                                    if (heldAccessories.indexOf(item) >= 0) {
                                        return
                                    }
                                }

                                // Add female object if female body
                                if (body === sprites.bodyObjectShe || body === sprites.bodyObjectSheAbs) {
                                    if (item.femaleObject) {
                                        item = item.femaleObject;
                                        newItem = newItem.femaleObject;
                                    }
                                }

                                item.designs.map(function (x, y) {
                                    // Duplicate sprite
                                    let newSprite = new PIXI.Sprite(x.sprite.texture);

                                    // Add color
                                    let spriteColor = characterData[key]['colors'][y];
                                    if (!spriteColor) {
                                        // For backwards compatibility with new designs added to part (e.g hair streak)
                                        // Set color to previous design's color if not found
                                        spriteColor = characterData[key]['colors'][y - 1];
                                    }
                                    x.defaultColor = spriteColor; // change defaultColor
                                    newSprite.tint = x.defaultColor;

                                    // Add empty graphic body/eye color depending on light or dark theme
                                    if (characterData['empty_graphic']) {
                                        if (key === 'body') {
                                            if (characterBackgroundImage) {
                                                newSprite.tint = '0x4D4D4D';
                                            } else {
                                                newSprite.tint = '0xF2F2F2';
                                            }
                                        }
                                        else if (key === 'eyes') {
                                            if (characterBackgroundImage) {
                                                newSprite.tint = '0x353535';
                                            } else {
                                                newSprite.tint = '0xC9C9C9';
                                            }
                                        }
                                    }

                                    // Add parts to stage
                                    if (match) {
                                        newSprite.parentLayer = characterLayer
                                    }
                                    else {
                                        newSprite.parentLayer = layer
                                    }
                                    newSprite.zIndex = x.zIndex;

                                    // Get x position of character
                                    let xPos;
                                    if (match) {
                                        xPos = (i + 1) * division;

                                        let width = x.sprite.width;
                                        // Set width of larger items (flags, TGI trophy) to standard accessory width for proper positioning
                                        if (sprites.flags.indexOf(item) >= 0 || sprites.temporaryTrophyObjects.indexOf(item) >= 0) {
                                            width = 99
                                        }

                                        xPos -= width / 2;

                                        // Position team members next to each other using median
                                        let offset = width / 2;
                                        // Get median using size of team
                                        let median = getMedian(Array.from(Array(teams[teamIndex].length).keys()));

                                        let aboveMedian = false;
                                        let belowMedian = false;

                                        // Arrange graphics around center (median) of team
                                        if (characterIndex < median) {
                                            belowMedian = true;
                                        } else if (characterIndex > median) {
                                            aboveMedian = true;
                                        }

                                        // Set team size individually for each team
                                        tagTeamSize = teams[teamIndex].length;

                                        // Offset brings teams closer together. Add if less than 10 teams
                                        if (teams.length < 10) {
                                            offset = 12 + (tagTeamSize * 10);
                                            if (teams.length > 4) {
                                                offset /= teams.length;
                                            } else if (tagTeamSize > 2) {
                                                offset /= tagTeamSize - 1;
                                            }

                                            let secondaryOffset = Math.abs(median - characterIndex);

                                            // Bring closer to center, going right
                                            if (belowMedian) {
                                                offset *= secondaryOffset;
                                                xPos += offset;
                                            }
                                            // Bring closer to center, going left
                                            else if (aboveMedian) {
                                                offset *= secondaryOffset;
                                                xPos -= offset;
                                            }
                                        }
                                    }

                                    // Fix hair positioning bug
                                    if (match && key === 'hair') {
                                        xPos = Math.floor(xPos)
                                    }
                                    else {
                                        xPos = Math.round(xPos);
                                    }

                                    // Set position
                                    if (xPos) {
                                        newSprite.position.x = xPos;
                                    } else {
                                        newSprite.position.x = x.sprite.position.x;
                                    }
                                    let yPos = x.sprite.position.y;
                                    newSprite.position.y = yPos;

                                    characterContainer.addChild(newSprite);
                                    if (!match) {
                                        stageObjects.addChild(newSprite);
                                    }

                                    // Set new sprite to duplicate object
                                    newItem.designs[y].sprite = newSprite;
                                });

                                addedParts[key] = newItem;
                            } else {
                                addedParts[key] = null
                            }
                        });

                        if (match) {
                            stageObjects.addChild(characterContainer)
                        }

                        // Show title, if present, and not removeClothes
                        if (characterData['title'] && !removeClothes) {
                            let titleData = characterData['title'];
                            let smallTitleData = getSmallTitleData(titleData);

                            // Go through small title parts
                            Object.keys(smallTitleData).forEach(function (key) {
                                let item = smallTitleData[key]['object'];
                                let newItem = smallTitleData[key]['object'];
                                item.designs.map(function (x, y) {
                                    // Duplicate sprite
                                    let newSprite = new PIXI.Sprite(x.sprite.texture);

                                    // Add color
                                    let spriteColor = smallTitleData[key]['colors'][y];
                                    x.defaultColor = spriteColor; // change defaultColor
                                    newSprite.tint = x.defaultColor;

                                    // Add parts to stage
                                    if (match) {
                                        newSprite.parentLayer = characterLayer
                                    }
                                    else {
                                        newSprite.parentLayer = layer
                                    }
                                    newSprite.zIndex = x.zIndex;

                                    // Get x position of character
                                    let xPos;
                                    if (match) {
                                        xPos = (i + 1) * division;

                                        let width = x.sprite.width;

                                        xPos -= width / 2;

                                        // Position team members next to each other using median
                                        let median = getMedian(Array.from(Array(teams[teamIndex].length).keys()));

                                        let aboveMedian = false;
                                        let belowMedian = false;

                                        // Arrange graphics around center (median) of team
                                        if (characterIndex < median) {
                                            belowMedian = true;
                                        } else if (characterIndex > median) {
                                            aboveMedian = true;
                                        }

                                        // Set team size individually for each team
                                        tagTeamSize = teams[teamIndex].length;

                                        // Offset brings teams closer together
                                        let offset = 12 + (tagTeamSize * 10);
                                        if (teams.length > 4) {
                                            offset /= teams.length;
                                        } else if (tagTeamSize > 2) {
                                            offset /= tagTeamSize - 1;
                                        }

                                        let secondaryOffset = Math.abs(median - characterIndex);

                                        // Bring closer to center, going right
                                        if (belowMedian) {
                                            offset *= secondaryOffset;
                                            xPos += offset;
                                        }
                                        // Bring closer to center, going left
                                        else if (aboveMedian) {
                                            offset *= secondaryOffset;
                                            xPos -= offset;
                                        }
                                    }
                                    xPos = Math.round(xPos);

                                    // Set position
                                    if (xPos) {
                                        newSprite.position.x = xPos;
                                    } else {
                                        newSprite.position.x = x.sprite.position.x;
                                    }
                                    let yPos = x.sprite.position.y;
                                    newSprite.position.y = yPos;

                                    characterContainer.addChild(newSprite);
                                    if (!match) {
                                        stageObjects.addChild(newSprite);
                                    }

                                    // Set new sprite to duplicate object
                                    newItem.designs[y].sprite = newSprite;
                                });
                            })
                        }

                        // Move rows above and below each other if more than 1 row
                        if (rows.length > 1) {
                            // If 2 rows, space second row apart more
                            if (rows.length === 2 && rowIndex === 1) {
                                characterContainer.y += 50;
                            }
                            else if (rows.length === 2 && rowIndex === 0) {
                                characterContainer.y -= 35;
                            }
                            else if (rows.length === 3 && rowIndex !== 0) {
                                // If 3 rows, space second and third rows more
                                characterContainer.y += (rowIndex - 1) * 60;
                            }
                            else {
                                characterContainer.y += (rowIndex - 1) * 50;
                            }
                        }

                        // Move row down for hanging championships
                        if (match && match['hangingChampionships'] && match['hangingChampionships'].length > 0) {
                            characterContainer.y += 30;
                        }

                    })

                });

                // Set added parts for editing
                addedBody = addedParts['body'];
                addedBottoms = addedParts['bottoms'];
                addedTorso = addedParts['torso'];
                addedHair = addedParts['hair'];
                addedShoes = addedParts['shoes'];
                addedElbow = addedParts['elbow'];
                addedFacialHair = addedParts['facialHair'];
                addedAccessory = addedParts['accessory'];
                addedAccessory2 = addedParts['accessory2'];
                addedAccessory3 = addedParts['accessory3'];
                addedKneepad = addedParts['knee'];
                addedFacepaint = addedParts['facepaint'];
                addedTattoo = addedParts['tattoo'];
                addedEyes = addedParts['eyes'];
                addedTemporaryInjury = addedParts['temporaryInjury'];
                addedTemporaryTrophy = addedParts['temporaryTrophy'];

                // Add control data if editing
                if (!jsonData) {

                    // Update part controls
                    if (!selected) {
                        // Select body upon initial load
                        selected = addedBody
                    } else {
                        // Add selected part again because it changed
                        selected = addedParts[selectedPart];
                    }
                    x = selections.indexOf(selected);
                    $('.selection-number').text(x + 1);
                    if (selected) {
                        updateDesigns(selected)
                    }
                }
            }

            // Adjust graphic for poster
            if (posterData) {
                let posterStyleData = posterData['styleData'];

                if (posterData['annualTournament']) {
                    posterData['styleData']['backgroundColor'] = '7D236F';
                    let textStartingY;

                    try {
                        if (posterData['type'] === 5) {
                            posterStyleData['backgroundObject'] = 2;

                            // Scale up superstars, move
                            stageObjects.children.forEach(function (c, i) {
                                c.scale.set(1.2, 1.2);
                                c.x -= 32;
                                c.y += 230;
                                if (i < 8) {
                                    c.x -= i * 4;
                                }
                                else {
                                    c.x -= (i - 8) * 4
                                }
                            });

                            // Set z indexes
                            teamLayers.forEach(function (l, i) {
                                if (i < 8) {
                                    l.zIndex = 30
                                }
                                else {
                                    l.zIndex = 50
                                }
                            });
                            teamLayers[0].zIndex = 35;
                            teamLayers[2].zIndex = 35;
                            teamLayers[5].zIndex = 35;

                            teamLayers[9].zIndex = 100;
                            teamLayers[12].zIndex = 100;
                            teamLayers[14].zIndex = 100;

                            // Adjust text position
                            textStartingY = 50;
                        }

                        else if (posterData['type'] === 6) {
                            posterStyleData['backgroundObject'] = 2;

                            // Scale up superstars, move
                            stageObjects.children.forEach(function (c) {
                                c.scale.set(1.4, 1.4);
                            });
                            let xOffset = 21;
                            stageObjects.children.slice(0, 4).forEach(function(c, i) {
                               c.x += 22 + i * xOffset;
                               c.y += 140;
                            });
                            stageObjects.children.slice(4, 8).forEach(function(c, i) {
                               c.x += -275 + i * xOffset;
                               c.y += 220;
                            });
                            stageObjects.children.slice(8, 12).forEach(function(c, i) {
                               c.x += 22 + i * xOffset;
                               c.y += 218;
                            });
                            stageObjects.children.slice(12, 16).forEach(function(c, i) {
                               c.x += -275 + i * xOffset;
                               c.y += 306;
                            });

                            // Set z indexes
                            teamLayers.forEach(function (l, i) {
                                if (i < 4) {
                                    l.zIndex = 30
                                }
                                else if (i < 8) {
                                    l.zIndex = 40
                                }
                                else if (i < 12) {
                                    l.zIndex = 50
                                }
                                else {
                                    l.zIndex = 60
                                }
                            });

                            // Adjust text position
                            textStartingY = 40;
                        }

                        else if (posterData['type'] === 7) {
                            posterStyleData['backgroundObject'] = 1;

                            // Scale up superstars, move
                            stageObjects.children.forEach(function (c) {
                                c.scale.set(1, 1);
                            });
                            stageObjects.children.slice(0, 4).forEach(function(c, i) {
                               c.x = 92 + i * 10;
                               c.y = 367;
                            });
                            stageObjects.children.slice(4, 8).forEach(function(c, i) {
                               c.x = -124 + i * 10;
                               c.y = -27;
                            });
                            stageObjects.children[0].position.y -= 15;
                            stageObjects.children[3].position.y -= 15;
                            stageObjects.children[4].position.y += 15;
                            stageObjects.children[7].position.y += 15;
                            stageObjects.children[8].position.set(32, 307);
                            stageObjects.children[9].position.set(290, 307);
                            stageObjects.children[10].position.set(-100, 217);
                            stageObjects.children[11].position.set(207, 217);
                            stageObjects.children[12].position.set(-202, 122);
                            stageObjects.children[13].position.set(101, 122);
                            stageObjects.children[14].position.set(-285, 32);
                            stageObjects.children[15].position.set(-28, 32);

                            // Set z indexes
                            teamLayers[0].zIndex = 90;
                            teamLayers[1].zIndex = 95;
                            teamLayers[2].zIndex = 96;
                            teamLayers[3].zIndex = 90;

                            teamLayers[8].zIndex = 85;
                            teamLayers[9].zIndex = 85;
                            teamLayers[10].zIndex = 80;
                            teamLayers[11].zIndex = 80;
                            teamLayers[12].zIndex = 75;
                            teamLayers[13].zIndex = 75;
                            teamLayers[14].zIndex = 70;
                            teamLayers[15].zIndex = 70;

                            teamLayers[4].zIndex = 65;
                            teamLayers[5].zIndex = 61;
                            teamLayers[6].zIndex = 60;
                            teamLayers[7].zIndex = 65;

                            // Adjust text position
                            textStartingY = 258;
                        }
                    } catch (error) {
                        captureError(error)
                    }

                    // Add 'The Grand Invitational' text
                    let textGrandStyle = new PIXI.TextStyle({ fontFamily: ['Cantarell'], fontWeight: 700, fontSize: 51, fill: '#F5D230', lineJoin: 'round', letterSpacing: 5});
                    let grandText = new PIXI.Text('GRAND', textGrandStyle);
                    grandText.x = (renderer.width / 2) - (grandText.width / 2);
                    grandText.y = textStartingY + 22;
                    grandText.parentLayer = layer;
                    stageObjects.addChild(grandText);

                    let textInvitationalStyle = new PIXI.TextStyle({fontFamily: ['Cantarell'], fontWeight: 700, fontSize: 25, fill: '#E8D9E7', letterSpacing: 2, lineJoin: 'round'});
                    let invitationalText = new PIXI.Text('INVITATIONAL', textInvitationalStyle);
                    invitationalText.x = (renderer.width / 2) - (invitationalText.width / 2) + 1;
                    invitationalText.y = textStartingY + 82;
                    invitationalText.parentLayer = layer;
                    stageObjects.addChild(invitationalText);

                    let textTheStyle = new PIXI.TextStyle({fontFamily: ['Cantarell'], fontWeight: 700, fontSize: 19, fill: '#E8D9E7', lineJoin: 'round', letterSpacing: 1});
                    let theText = new PIXI.Text('THE', textTheStyle);
                    theText.x = (renderer.width / 2) - (theText.width / 2);
                    theText.y = textStartingY;
                    theText.parentLayer = layer;
                    stageObjects.addChild(theText);
                }
                else {

                    // Get y offset (if text on top)
                    let yOffset = 0;

                    if (posterData['type'] === 1) {

                        // Scale up superstars
                        stageObjects.children.forEach(function (x) {
                            x.scale.set(1.4, 1.4);
                        });

                        if (posterStyleData['textPosition'] === 'top') {
                            yOffset = 100;
                        }

                        // 1st row
                        let firstRowY = 170 + yOffset;
                        stageObjects.children[0].position.set(52, firstRowY);
                        stageObjects.children[1].position.set(222, firstRowY);
                        stageObjects.children[2].position.set(36, firstRowY);

                        teamLayers[0].zIndex = 100;
                        teamLayers[1].zIndex = 101;
                        teamLayers[2].zIndex = 100;

                        // 2nd row
                        let secondRowY = 70 + yOffset;
                        stageObjects.children[3].position.set(-168, secondRowY);
                        stageObjects.children[4].position.set(42, secondRowY);
                        stageObjects.children[5].position.set(-165, secondRowY);

                        teamLayers[3].zIndex = 50;
                        teamLayers[4].zIndex = 51;
                        teamLayers[5].zIndex = 50;

                        // 3rd row
                        let thirdRowY = -6 + yOffset;
                        stageObjects.children[6].position.set(-312, thirdRowY);
                        stageObjects.children[7].position.set(-216, thirdRowY);

                        teamLayers[6].zIndex = 40;
                        teamLayers[7].zIndex = 41;

                        // 4th row
                        let fourthRowY = -44 + yOffset;
                        stageObjects.children[8].position.set(-367, fourthRowY);

                        teamLayers[8].zIndex = 30;
                    }
                    else if (posterData['type'] === 2) {

                        // Scale up superstars
                        stageObjects.children.forEach(function (x, i) {
                            if (i === 0) {
                                x.scale.set(1.55, 1.55)
                            }
                            else {
                                x.scale.set(1.4, 1.4)
                            }
                        });

                        if (posterStyleData['textPosition'] === 'top') {
                            yOffset = 70;
                        }

                        // 1st row
                        let firstRowY = 130 + yOffset;
                        stageObjects.children[0].position.set(133, firstRowY);

                        teamLayers[0].zIndex = 100;

                        // 2nd row
                        let secondRowY = 130 + yOffset;
                        stageObjects.children[1].position.set(-62, secondRowY);
                        stageObjects.children[2].position.set(62, secondRowY);

                        teamLayers[1].zIndex = 50;
                        teamLayers[2].zIndex = 51;

                        // 3rd row
                        let thirdRowY = 60 + yOffset;
                        stageObjects.children[3].position.set(-203, thirdRowY);
                        stageObjects.children[4].position.set(-177, thirdRowY);

                        teamLayers[3].zIndex = 40;
                        teamLayers[4].zIndex = 41;

                        // 4th row
                        let fourthRowY = yOffset;
                        stageObjects.children[5].position.set(-332, fourthRowY);

                        teamLayers[5].zIndex = 30;
                    }
                    else if (posterData['type'] === 3) {

                        // Scale up superstars
                        stageObjects.children.forEach(function (x, i) {
                            if (i === 0) {
                                x.scale.set(1.95, 1.95)
                            }
                            else if (i === 1 || i === 2) {
                                x.scale.set(1.7, 1.7)
                            }
                            else {
                                x.scale.set(1.4, 1.4)
                            }
                        });

                        if (posterStyleData['textPosition'] === 'top') {
                            yOffset = 80;
                        }

                        // 1st row
                        let firstRowY = 10 + yOffset;
                        stageObjects.children[0].position.set(84, firstRowY);

                        teamLayers[0].zIndex = 100;

                        // 2nd row
                        let secondRowY = 25 + yOffset;
                        stageObjects.children[1].position.set(-121, secondRowY);
                        stageObjects.children[2].position.set(-74, secondRowY);

                        teamLayers[1].zIndex = 50;
                        teamLayers[2].zIndex = 51;

                        // 3rd row
                        let thirdRowY = 40 + yOffset;
                        stageObjects.children[3].position.set(-370, thirdRowY);
                        stageObjects.children[4].position.set(-149, thirdRowY);

                        teamLayers[3].zIndex = 40;
                        teamLayers[4].zIndex = 41;
                    }
                    else if (posterData['type'] === 4) {

                        // Scale up superstars
                        stageObjects.children.forEach(function (x) {
                            x.scale.set(2, 2)
                        });

                        if (posterStyleData['textPosition'] === 'top') {
                            yOffset = 60;
                        }

                        // 1st row
                        let firstRowY = yOffset;
                        stageObjects.children[0].position.set(-1, firstRowY);

                        teamLayers[0].zIndex = 100;

                        // 2nd row
                        let secondRowY = yOffset;
                        stageObjects.children[1].position.set(-355, secondRowY);
                        stageObjects.children[2].position.set(-361, secondRowY);

                        teamLayers[1].zIndex = 50;
                        teamLayers[2].zIndex = 51;
                    }

                    // Select font
                    let fontChoices = [
                        {fontFamily: '"Oswald"', fontSize: 46},
                        {fontFamily: '"Quantico"', fontSize: 42},
                        {fontFamily: '"Saira Stencil One"', fontSize: 42},
                        {fontFamily: '"Orbitron"', fontSize: 36},
                        {fontFamily: '"Cinzel Decorative"', fontSize: 38},
                        {fontFamily: '"Century Gothic"', fontSize: 42},
                        {fontFamily: '"Mukta Mahee"', fontSize: 44}
                    ];
                    let selectedFont = fontChoices[posterStyleData['fontFamilyObject']];

                    // Set text style
                    let style = new PIXI.TextStyle({
                        fontFamily: [selectedFont.fontFamily, 'Century Gothic'],
                        fontWeight: 700,
                        fontSize: selectedFont.fontSize,
                        fill: '#' + posterStyleData['fontColor'],
                        wordWrap: true,
                        wordWrapWidth: 400,
                        lineJoin: 'round',
                        align: 'center'
                    });

                    // Reduce font size if long text
                    if (posterData['eventName'].length >= 30) {
                        style.fontSize -= 12;
                    }

                    // Add text
                    let richText = new PIXI.Text(posterData['eventName'].toUpperCase(), style);
                    richText.x = (renderer.width / 2) - (richText.width / 2);
                    if (posterStyleData['textPosition'] === 'top') {
                        richText.y = 75 - (richText.height / 2);
                    }
                    else {
                        richText.y = (renderer.height) - (richText.height / 2) - 75;
                    }
                    richText.parentLayer = layer;
                    stageObjects.addChild(richText);
                }

                // Select background
                let backgroundObject = sprites.backgroundObjects[posterStyleData['backgroundObject']];
                let backgroundColor = '0x' + posterStyleData['backgroundColor'];

                // Add background
                let backgroundSprite = new PIXI.Sprite(backgroundObject.texture);
                backgroundSprite.tint = backgroundColor;
                backgroundSprite.zIndex = -100;
                if (posterStyleData['textPosition'] === 'top' && backgroundObject === sprites.posterBackground3 &&
                    !posterData['annualTournament']) {
                    // Flip background 3 so dark part is on top
                    backgroundSprite.anchor.y = 1;
                    backgroundSprite.scale.y *= -1;
                }
                stageObjects.addChild(backgroundSprite);
            }

            // Add special segment sprites
            if (match && match['special']) {
                if (match['name'] === 'Car Explosion') {

                    // Action text
                    if (segmentAction) {

                        // Remove sprites if present
                        if (data) {
                            characterContainer.children.map(function (x) {
                                x.destroy()
                            });
                            stageObjects.children.map(function (x) {
                                x.destroy()
                            });
                        }

                        // Add car fire sprite
                        sprites.specialSegmentsCarFire.parentLayer = layer;
                        sprites.specialSegmentsCarFire.x = 76;
                        sprites.specialSegmentsCarFire.y = 38;
                        sprites.specialSegmentsCarFire.zIndex = -9;
                        stageObjects.addChild(sprites.specialSegmentsCarFire);

                    }
                    else {
                        // Move sprite near car
                        stageObjects.children.map(function (x) {
                            x.x -= 60;
                        });
                    }

                    // Add car sprite
                    sprites.specialSegmentsCar.parentLayer = layer;
                    sprites.specialSegmentsCar.x = -2;
                    sprites.specialSegmentsCar.y = 92;
                    sprites.specialSegmentsCar.zIndex = -10;
                    stageObjects.addChild(sprites.specialSegmentsCar);
                }

                else if (match['name'] === 'Helicopter Raid') {

                    // Action text
                    if (segmentAction) {
                        if (data) {
                            characterContainer.scale.set(0.6, 0.6);
                            characterContainer.x = 128;
                            characterContainer.y = 107;
                        }

                        sprites.specialSegmentsHelicopterBuilding.parentLayer = layer;
                        sprites.specialSegmentsHelicopterBuilding.x = 0;
                        sprites.specialSegmentsHelicopterBuilding.y = 255;
                        sprites.specialSegmentsHelicopterBuilding.zIndex = -12;
                        stageObjects.addChild(sprites.specialSegmentsHelicopterBuilding);
                        sprites.specialSegmentsHelicopterBuildingLights.parentLayer = layer;
                        sprites.specialSegmentsHelicopterBuildingLights.x = 0;
                        sprites.specialSegmentsHelicopterBuildingLights.y = 284;
                        sprites.specialSegmentsHelicopterBuildingLights.zIndex = -8;
                        stageObjects.addChild(sprites.specialSegmentsHelicopterBuildingLights);

                        sprites.specialSegmentsHelicopter.y = 91;


                    }
                    else {
                        // Remove sprites if present
                        if (data) {
                            characterContainer.children.map(function (x) {
                                x.destroy()
                            });
                            stageObjects.children.map(function (x) {
                                x.destroy()
                            });
                        }

                        sprites.specialSegmentsHelicopter.y = 50;
                    }

                    sprites.specialSegmentsHelicopter.parentLayer = layer;
                    sprites.specialSegmentsHelicopter.x = 10;
                    sprites.specialSegmentsHelicopter.zIndex = -10;
                    stageObjects.addChild(sprites.specialSegmentsHelicopter);

                }

                else if (match['name'] === 'Hosedown') {

                    // Action text
                    let truckXPos = -220;
                    if (segmentAction) {
                        if (data) {
                            characterContainer.scale.set(0.7, 0.7);
                            characterContainer.x = 169;
                            characterContainer.y = 76;
                        }

                        sprites.specialSegmentsLemonadeTruckSpray.parentLayer = layer;
                        sprites.specialSegmentsLemonadeTruckSpray.x = 266;
                        sprites.specialSegmentsLemonadeTruckSpray.y = 169;
                        sprites.specialSegmentsLemonadeTruckSpray.zIndex = 40;
                        stageObjects.addChild(sprites.specialSegmentsLemonadeTruckSpray);

                        truckXPos = 20;
                    }
                    else {
                        // Remove sprites if present
                        if (data) {
                            characterContainer.children.map(function (x) {
                                x.destroy()
                            });
                            stageObjects.children.map(function (x) {
                                x.destroy()
                            });
                        }

                    }

                    sprites.specialSegmentsLemonadeTruck.parentLayer = layer;
                    sprites.specialSegmentsLemonadeTruck.x = truckXPos;
                    sprites.specialSegmentsLemonadeTruck.y = 85;
                    sprites.specialSegmentsLemonadeTruck.zIndex = -10;
                    stageObjects.addChild(sprites.specialSegmentsLemonadeTruck);

                }

                else if (match['name'] === 'Stunt Dive') {

                    // Action text
                    if (segmentAction) {
                        if (data) {
                            characterContainer.children.map(function (x) {
                                x.destroy()
                            });
                            stageObjects.children.map(function (x) {
                                x.destroy()
                            });
                        }
                    }
                    else {
                        if (data) {
                            characterContainer.scale.set(0.6, 0.6);
                            characterContainer.x = 41;
                            characterContainer.y = 46;
                        }
                    }

                    sprites.specialSegmentsStage.parentLayer = layer;
                    sprites.specialSegmentsStage.x = 28;
                    sprites.specialSegmentsStage.y = 182;
                    sprites.specialSegmentsStage.zIndex = -10;
                    stageObjects.addChild(sprites.specialSegmentsStage);

                    sprites.specialSegmentsStageRailing.parentLayer = layer;
                    sprites.specialSegmentsStageRailing.x = -2;
                    sprites.specialSegmentsStageRailing.y = 158;
                    sprites.specialSegmentsStageRailing.zIndex = 40;
                    stageObjects.addChild(sprites.specialSegmentsStageRailing);
                }

                else if (match['name'] === 'Dummy Wrestling') {

                    if (data) {
                        characterContainer.x += 10;
                    }

                    // Action text
                    if (segmentAction) {
                        if (data) {
                            characterContainer.x -= 76;
                        }
                        sprites.specialSegmentsDummy.parentLayer = layer;
                        sprites.specialSegmentsDummy.x = 260;
                        sprites.specialSegmentsDummy.y = 71;
                        sprites.specialSegmentsDummy.zIndex = 40;
                        stageObjects.addChild(sprites.specialSegmentsDummy);

                    }
                }

                else if (match['name'] === 'Timely Rescue') {

                    // Action text
                    if (segmentAction) {
                        if (data) {
                            characterContainer.destroy();
                            stageObjects.children[0].x += 90;
                            stageObjects.children[0].y += 30;
                        }
                        sprites.specialSegmentsAmbulance.parentLayer = layer;
                        sprites.specialSegmentsAmbulance.x = 0;
                        sprites.specialSegmentsAmbulance.y = 30;
                        sprites.specialSegmentsAmbulance.zIndex = -10;
                        stageObjects.addChild(sprites.specialSegmentsAmbulance);
                    }
                    else {
                        if (data) {
                            stageObjects.children[1].scale.set(0.8, 0.8);
                            stageObjects.children[1].y += 0;
                            stageObjects.children[1].x += 118;

                            stageObjects.children[0].x += 70;
                        }
                    }
                }

                else if (match['name'] === 'Celebrity Beatdown') {

                    let celebrityName = match['pronouns'][1]['name'];

                    // Add celebrity sprite
                    let celebritySprite;
                    let celebrityYPos;
                    if (celebrityName === 'American Queen' || celebrityName === 'Opera Queen') {
                        celebritySprite = sprites.specialSegmentsCelebrityAmericanQueen;
                        celebrityYPos = 56;
                    }
                    else if (celebrityName === 'Prezz' || celebrityName === 'Mister Prez') {
                        celebritySprite = sprites.specialSegmentsCelebrityPrezz;
                        celebrityYPos = 62;
                    }
                    else if (celebrityName === 'Big T' || celebrityName === 'Big Schwartz') {
                        celebritySprite = sprites.specialSegmentsCelebrityBigT;
                        celebrityYPos = 56;
                    }

                    celebritySprite.parentLayer = layer;
                    celebritySprite.x = 180;
                    celebritySprite.y = celebrityYPos;
                    celebritySprite.zIndex = 0;

                    // Action Text
                    if (segmentAction) {
                        if (data) {
                            characterContainer.x += 75;
                        }
                        celebritySprite.x -= 75
                    }
                    else {
                        if (data) {
                            characterContainer.children.map(function (x) {
                                x.destroy()
                            });
                            stageObjects.children.map(function (x) {
                                x.destroy()
                            });
                        }
                    }

                    stageObjects.addChild(celebritySprite);
                }

                else if (match['name'] === 'Anti-Company Rant') {

                    // Action text
                    if (segmentAction) {
                        sprites.specialSegmentsRantSpeech.parentLayer = layer;
                        sprites.specialSegmentsRantSpeech.x = 42;
                        sprites.specialSegmentsRantSpeech.y = 19;
                        sprites.specialSegmentsRantSpeech.zIndex = 40;
                        stageObjects.addChild(sprites.specialSegmentsRantSpeech);

                        if (data) {
                            characterContainer.scale.set(2, 2);
                            characterContainer.x -= 216;
                            characterContainer.y -= 0;
                        }
                    }
                    else {
                        sprites.specialSegmentsRantMic.parentLayer = layer;
                        sprites.specialSegmentsRantMic.x = 238;
                        sprites.specialSegmentsRantMic.y = 153;
                        sprites.specialSegmentsRantMic.zIndex = 10;
                        stageObjects.addChild(sprites.specialSegmentsRantMic);
                    }
                }

                else if (match['name'] === 'Love Making') {

                    // Move participant to left
                    if (data) {
                        characterContainer.x += 70;
                    }

                    // Get partner's pronoun
                    let partnerPronoun = match['pronouns'][match['pronouns'].length - 1]['partnerPronoun'];
                    let partnerSprite;

                    if (segmentAction) {
                        // Get partner's nude sprite
                        if (partnerPronoun === 'he') {
                            partnerSprite = sprites.specialSegmentsLoveMakingManNude;
                        }
                        else {
                            partnerSprite = sprites.specialSegmentsLoveMakingWomanNude;
                        }

                        // Censor participant
                        if (match['pronouns'][0].pronoun !== 'he') {
                            sprites.specialSegmentsLoveMakingTopCensor.parentLayer = layer;
                            sprites.specialSegmentsLoveMakingTopCensor.x = 268;
                            sprites.specialSegmentsLoveMakingTopCensor.y = 124;
                            sprites.specialSegmentsLoveMakingTopCensor.zIndex = 40;
                            stageObjects.addChild(sprites.specialSegmentsLoveMakingTopCensor);

                            let specialSegmentsLoveMakingTopCensorDuplicate = new PIXI.Sprite(sprites.specialSegmentsLoveMakingTopCensor.texture);
                            specialSegmentsLoveMakingTopCensorDuplicate.parentLayer = layer;
                            specialSegmentsLoveMakingTopCensorDuplicate.x = 289;
                            specialSegmentsLoveMakingTopCensorDuplicate.y = 124;
                            specialSegmentsLoveMakingTopCensorDuplicate.zIndex = 40;
                            stageObjects.addChild(specialSegmentsLoveMakingTopCensorDuplicate);
                        }
                        sprites.specialSegmentsLoveMakingBottomCensor.parentLayer = layer;
                        sprites.specialSegmentsLoveMakingBottomCensor.x = 268;
                        sprites.specialSegmentsLoveMakingBottomCensor.y = 149;
                        sprites.specialSegmentsLoveMakingBottomCensor.zIndex = 40;
                        stageObjects.addChild(sprites.specialSegmentsLoveMakingBottomCensor);

                        // Add heart
                        sprites.specialSegmentsLoveMakingHeart.parentLayer = layer;
                        sprites.specialSegmentsLoveMakingHeart.x = 195;
                        sprites.specialSegmentsLoveMakingHeart.y = 60;
                        sprites.specialSegmentsLoveMakingHeart.zIndex = -10;
                        stageObjects.addChild(sprites.specialSegmentsLoveMakingHeart);

                    }
                    else {
                        // Get partner's clothed sprite
                        if (partnerPronoun === 'he') {
                            partnerSprite = sprites.specialSegmentsLoveMakingManClothed;
                        }
                        else {
                            partnerSprite = sprites.specialSegmentsLoveMakingWomanClothed;
                        }
                    }

                    // Add partner's sprite
                    partnerSprite.parentLayer = layer;
                    partnerSprite.x = 350;
                    partnerSprite.y = 65;
                    stageObjects.addChild(partnerSprite);

                    // Add bed
                    sprites.specialSegmentsLoveMakingBed.parentLayer = layer;
                    sprites.specialSegmentsLoveMakingBed.x = 18;
                    sprites.specialSegmentsLoveMakingBed.y = 147;
                    sprites.specialSegmentsLoveMakingBed.zIndex = -10;
                    stageObjects.addChild(sprites.specialSegmentsLoveMakingBed);
                }

                else if (match['name'] === 'Ring Invasion') {

                    // Scale down participant, move to center
                    if (data) {
                        characterContainer.scale.set(0.86, 0.86);
                        characterContainer.x += 33;
                        characterContainer.y += 25;
                    }

                    // Add ring and ropes
                    sprites.specialSegmentsRing.parentLayer = layer;
                    sprites.specialSegmentsRing.x = 0;
                    sprites.specialSegmentsRing.y = 228;
                    sprites.specialSegmentsRing.zIndex = 40;
                    stageObjects.addChild(sprites.specialSegmentsRing);

                    sprites.specialSegmentsRingRopes.parentLayer = layer;
                    sprites.specialSegmentsRingRopes.x = 0;
                    sprites.specialSegmentsRingRopes.y = 139;
                    sprites.specialSegmentsRingRopes.zIndex = 40;
                    stageObjects.addChild(sprites.specialSegmentsRingRopes);

                    if (segmentAction) {
                        // Add people
                        sprites.specialSegmentsRingPeopleTop.parentLayer = layer;
                        sprites.specialSegmentsRingPeopleTop.x = -12;
                        sprites.specialSegmentsRingPeopleTop.y = 80;
                        sprites.specialSegmentsRingPeopleTop.zIndex = -10;
                        stageObjects.addChild(sprites.specialSegmentsRingPeopleTop);

                        sprites.specialSegmentsRingPeopleBottom.parentLayer = layer;
                        sprites.specialSegmentsRingPeopleBottom.x = -12;
                        sprites.specialSegmentsRingPeopleBottom.y = 184;
                        sprites.specialSegmentsRingPeopleBottom.zIndex = 41;
                        stageObjects.addChild(sprites.specialSegmentsRingPeopleBottom);
                    }
                }

            }

            // Add gimmick match graphics
            if (match && match['gimmickMatchGraphic']) {

                let newMathRandom = new Math.seedrandom(match['uid']);
                let ladderObjects = [sprites.gimmickMatchLadderBlack, sprites.gimmickMatchLadderGrey, sprites.gimmickMatchLadderOrange];
                let tableObjects = [sprites.gimmickMatchTableBrown, sprites.gimmickMatchTableDarkBrown, sprites.gimmickMatchTableLightBrown];
                let chairObjects = [sprites.gimmickMatchChairBiege, sprites.gimmickMatchChairBlack, sprites.gimmickMatchChairBlue];
                let casketObjects = [sprites.gimmickMatchCasketBrown, sprites.gimmickMatchCasketPurple, sprites.gimmickMatchCasketLightBrown];
                let parkingLotObjects = [sprites.gimmickMatchParkingLotA, sprites.gimmickMatchParkingLotB];
                let ladderWeights = [10, 4, 1];
                let tableWeights = [4, 10, 2];
                let chairWeights = [8, 10, 5];
                let casketWeights = [10, 10, 4];
                let parkingLotWeights = [10, 10];

                // Ladder
                if (['ladder', 'ladder_black', 'ladder_grey', 'ladder_orange'].indexOf(match['gimmickMatchGraphic']) >= 0) {

                    let gimmickMatchLadderSprite;
                    if (match['gimmickMatchGraphic'] === 'ladder') {
                        gimmickMatchLadderSprite = pickUsingWeights(ladderObjects, ladderWeights, newMathRandom());
                    }
                    else if (match['gimmickMatchGraphic'] === 'ladder_black') {
                        gimmickMatchLadderSprite = sprites.gimmickMatchLadderBlack
                    }
                    else if (match['gimmickMatchGraphic'] === 'ladder_grey') {
                        gimmickMatchLadderSprite = sprites.gimmickMatchLadderGrey
                    }
                    else if (match['gimmickMatchGraphic'] === 'ladder_orange') {
                        gimmickMatchLadderSprite = sprites.gimmickMatchLadderOrange
                    }
                    gimmickMatchLadderSprite.parentLayer = layer;
                    gimmickMatchLadderSprite.x = 159;
                    gimmickMatchLadderSprite.y = 18;
                    gimmickMatchLadderSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchLadderSprite);

                    if (match['hangingChampionships'] && match['hangingChampionships'].length > 0) {
                        gimmickMatchLadderSprite.y += 30;
                    }

                    // Add large side ladder sprites if not 1 on 1 singles match
                    if (match['participants'].length > 2 || match['type'] === 'tag') {
                        let gimmickMatchLadderSpriteLarge = new PIXI.Sprite(gimmickMatchLadderSprite.texture);
                        gimmickMatchLadderSpriteLarge.scale.set(1.05, 1.05);
                        gimmickMatchLadderSpriteLarge.parentLayer = layer;
                        gimmickMatchLadderSpriteLarge.x = 10;
                        gimmickMatchLadderSpriteLarge.y = 7;
                        gimmickMatchLadderSpriteLarge.zIndex = -10;
                        stageObjects.addChild(gimmickMatchLadderSpriteLarge);

                        let gimmickMatchLadderSpriteLarge2 = new PIXI.Sprite(gimmickMatchLadderSprite.texture);
                        gimmickMatchLadderSpriteLarge2.scale.set(1.05, 1.05);
                        gimmickMatchLadderSpriteLarge2.parentLayer = layer;
                        gimmickMatchLadderSpriteLarge2.x = 300;
                        gimmickMatchLadderSpriteLarge2.y = 7;
                        gimmickMatchLadderSpriteLarge2.zIndex = -10;
                        stageObjects.addChild(gimmickMatchLadderSpriteLarge2);

                        if (match['hangingChampionships'] && match['hangingChampionships'].length > 0) {
                            gimmickMatchLadderSpriteLarge.y += 25;
                            gimmickMatchLadderSpriteLarge2.y += 25;
                        }
                    }
                }

                // Table
                else if (match['gimmickMatchGraphic'] === 'table') {
                    let gimmickMatchTableSprite = pickUsingWeights(tableObjects, tableWeights, newMathRandom());
                    gimmickMatchTableSprite.parentLayer = layer;
                    gimmickMatchTableSprite.x = -135;
                    gimmickMatchTableSprite.y = 163;
                    gimmickMatchTableSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchTableSprite);

                    let gimmickMatchTableSpriteDuplicate = new PIXI.Sprite(gimmickMatchTableSprite.texture);
                    gimmickMatchTableSpriteDuplicate.parentLayer = layer;
                    gimmickMatchTableSpriteDuplicate.x = 343;
                    gimmickMatchTableSpriteDuplicate.y = 163;
                    gimmickMatchTableSpriteDuplicate.zIndex = -10;
                    stageObjects.addChild(gimmickMatchTableSpriteDuplicate);

                    // Add standing table based on selected table sprite
                    let gimmickMatchTableStanding;
                    if (gimmickMatchTableSprite === sprites.gimmickMatchTableBrown) {
                        gimmickMatchTableStanding = sprites.gimmickMatchTableBrownStanding
                    }
                    else if (gimmickMatchTableSprite === sprites.gimmickMatchTableDarkBrown) {
                        gimmickMatchTableStanding = sprites.gimmickMatchTableDarkBrownStanding
                    }
                    else if (gimmickMatchTableSprite === sprites.gimmickMatchTableLightBrown) {
                        gimmickMatchTableStanding = sprites.gimmickMatchTableLightBrownStanding
                    }
                    gimmickMatchTableStanding.parentLayer = layer;
                    gimmickMatchTableStanding.x = 183;
                    gimmickMatchTableStanding.y = 50;
                    gimmickMatchTableStanding.zIndex = -10;
                    stageObjects.addChild(gimmickMatchTableStanding);
                }

                // Chair
                else if (match['gimmickMatchGraphic'] === 'chair') {
                    let gimmickMatchChairSprite = pickUsingWeights(chairObjects, chairWeights, newMathRandom());
                    let gimmickMatchChairLeftA = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairLeftA.parentLayer = layer;
                    gimmickMatchChairLeftA.x = 56;
                    gimmickMatchChairLeftA.y = 165;
                    gimmickMatchChairLeftA.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairLeftA);
                    let gimmickMatchChairLeftB = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairLeftB.parentLayer = layer;
                    gimmickMatchChairLeftB.x = 341;
                    gimmickMatchChairLeftB.y = 165;
                    gimmickMatchChairLeftB.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairLeftB);
                    let gimmickMatchChairRightA = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairRightA.parentLayer = layer;
                    gimmickMatchChairRightA.x = 11;
                    gimmickMatchChairRightA.y = 165;
                    gimmickMatchChairRightA.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairRightA);
                    let gimmickMatchChairRightB = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairRightB.parentLayer = layer;
                    gimmickMatchChairRightB.x = 386;
                    gimmickMatchChairRightB.y = 165;
                    gimmickMatchChairRightB.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairRightB);

                    // Pick new center chair sprite
                    gimmickMatchChairSprite = pickUsingWeights(chairObjects, chairWeights, newMathRandom());
                    let gimmickMatchChairCenterA = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairCenterA.parentLayer = layer;
                    gimmickMatchChairCenterA.x = 175;
                    gimmickMatchChairCenterA.y = 163;
                    gimmickMatchChairCenterA.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairCenterA);
                    let gimmickMatchChairCenterB = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairCenterB.parentLayer = layer;
                    gimmickMatchChairCenterB.x = 223;
                    gimmickMatchChairCenterB.y = 163;
                    gimmickMatchChairCenterB.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairCenterB);
                }

                // Tables, ladders and chairs
                else if (match['gimmickMatchGraphic'] === 'tables_ladders_chairs') {

                    // Two tables
                    let gimmickMatchTableSprite = pickUsingWeights(tableObjects, tableWeights, newMathRandom());
                    gimmickMatchTableSprite.parentLayer = layer;
                    gimmickMatchTableSprite.x = -135;
                    gimmickMatchTableSprite.y = 163;
                    gimmickMatchTableSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchTableSprite);
                    let gimmickMatchTableSpriteDuplicate = new PIXI.Sprite(gimmickMatchTableSprite.texture);
                    gimmickMatchTableSpriteDuplicate.parentLayer = layer;
                    gimmickMatchTableSpriteDuplicate.x = 343;
                    gimmickMatchTableSpriteDuplicate.y = 163;
                    gimmickMatchTableSpriteDuplicate.zIndex = -10;
                    stageObjects.addChild(gimmickMatchTableSpriteDuplicate);

                    // Ladder
                    let gimmickMatchLadderSprite = pickUsingWeights(ladderObjects, ladderWeights, newMathRandom());
                    gimmickMatchLadderSprite.parentLayer = layer;
                    gimmickMatchLadderSprite.x = 159;
                    gimmickMatchLadderSprite.y = 18;
                    gimmickMatchLadderSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchLadderSprite);

                    if (match['hangingChampionships'] && match['hangingChampionships'].length > 0) {
                        gimmickMatchLadderSprite.y += 30;
                    }

                    // Chairs
                    let gimmickMatchChairSprite = pickUsingWeights(chairObjects, chairWeights, newMathRandom());
                    gimmickMatchChairSprite.parentLayer = layer;
                    gimmickMatchChairSprite.x = 11;
                    gimmickMatchChairSprite.y = 165;
                    gimmickMatchChairSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairSprite);
                    let gimmickMatchChairSpriteDuplicate = new PIXI.Sprite(gimmickMatchChairSprite.texture);
                    gimmickMatchChairSpriteDuplicate.parentLayer = layer;
                    gimmickMatchChairSpriteDuplicate.x = 386;
                    gimmickMatchChairSpriteDuplicate.y = 165;
                    gimmickMatchChairSpriteDuplicate.zIndex = -10;
                    stageObjects.addChild(gimmickMatchChairSpriteDuplicate);
                }

                // Cage
                else if (['cage_grey', 'cage_red', 'cage_retro_blue', 'cage_retro_black'].indexOf(match['gimmickMatchGraphic']) >= 0) {
                    let gimmickMatchCageSprite;
                    if (match['gimmickMatchGraphic'] === 'cage_grey') {
                        gimmickMatchCageSprite = sprites.gimmickMatchCageGrey;
                    }
                    else if (match['gimmickMatchGraphic'] === 'cage_red') {
                        gimmickMatchCageSprite = sprites.gimmickMatchCageRed
                    }
                    else if (match['gimmickMatchGraphic'] === 'cage_retro_blue') {
                        gimmickMatchCageSprite = sprites.gimmickMatchCageRetroBlue
                    }
                    else if (match['gimmickMatchGraphic'] === 'cage_retro_black') {
                        gimmickMatchCageSprite = sprites.gimmickMatchCageRetroBlack
                    }
                    gimmickMatchCageSprite.parentLayer = layer;
                    gimmickMatchCageSprite.x = 0;
                    gimmickMatchCageSprite.y = 0;
                    gimmickMatchCageSprite.zIndex = 40;
                    stageObjects.addChild(gimmickMatchCageSprite);
                }

                // Ambulance
                else if (match['gimmickMatchGraphic'] === 'ambulance') {
                    sprites.gimmickMatchAmbulance.parentLayer = layer;
                    sprites.gimmickMatchAmbulance.x = -78;
                    sprites.gimmickMatchAmbulance.y = 30;
                    sprites.gimmickMatchAmbulance.zIndex = -10;
                    stageObjects.addChild(sprites.gimmickMatchAmbulance);
                }

                // Barbed Wire Ropes
                else if (match['gimmickMatchGraphic'] === 'barbed_wire_ropes') {

                    // Ropes
                    sprites.gimmickMatchBarbedWireRopes.parentLayer = layer;
                    sprites.gimmickMatchBarbedWireRopes.x = 0;
                    sprites.gimmickMatchBarbedWireRopes.y = 122;
                    sprites.gimmickMatchBarbedWireRopes.zIndex = 40;
                    stageObjects.addChild(sprites.gimmickMatchBarbedWireRopes);

                    // Boards
                    sprites.gimmickMatchBarbedWireBoard.parentLayer = layer;
                    sprites.gimmickMatchBarbedWireBoard.x = 12;
                    sprites.gimmickMatchBarbedWireBoard.y = 68;
                    sprites.gimmickMatchBarbedWireBoard.zIndex = -10;
                    stageObjects.addChild(sprites.gimmickMatchBarbedWireBoard);
                    let gimmickMatchBarbedWireBoardSpriteDuplicate = new PIXI.Sprite(sprites.gimmickMatchBarbedWireBoard.texture);
                    gimmickMatchBarbedWireBoardSpriteDuplicate.scale.x *= -1;
                    gimmickMatchBarbedWireBoardSpriteDuplicate.parentLayer = layer;
                    gimmickMatchBarbedWireBoardSpriteDuplicate.x = 424;
                    gimmickMatchBarbedWireBoardSpriteDuplicate.y = 68;
                    gimmickMatchBarbedWireBoardSpriteDuplicate.zIndex = -10;
                    stageObjects.addChild(gimmickMatchBarbedWireBoardSpriteDuplicate);
                }

                // Buried Alive
                else if (match['gimmickMatchGraphic'] === 'grave') {
                    sprites.gimmickMatchBuriedAlive.parentLayer = layer;
                    sprites.gimmickMatchBuriedAlive.x = 142;
                    sprites.gimmickMatchBuriedAlive.y = 77;
                    sprites.gimmickMatchBuriedAlive.zIndex = -10;
                    stageObjects.addChild(sprites.gimmickMatchBuriedAlive);
                }

                // Casket
                else if (match['gimmickMatchGraphic'] === 'casket') {
                    let gimmickMatchCasketSprite = pickUsingWeights(casketObjects, casketWeights, newMathRandom());
                    gimmickMatchCasketSprite.parentLayer = layer;
                    gimmickMatchCasketSprite.x = 115;
                    gimmickMatchCasketSprite.y = 134;
                    gimmickMatchCasketSprite.zIndex = 40;
                    stageObjects.addChild(gimmickMatchCasketSprite);
                }

                // Parking Lot
                else if (match['gimmickMatchGraphic'] === 'parking_lot') {
                    let gimmickMatchParkingLotSprite = pickUsingWeights(parkingLotObjects, parkingLotWeights, newMathRandom());
                    gimmickMatchParkingLotSprite.parentLayer = layer;
                    gimmickMatchParkingLotSprite.x = 0;
                    gimmickMatchParkingLotSprite.y = 81;
                    gimmickMatchParkingLotSprite.zIndex = -10;
                    stageObjects.addChild(gimmickMatchParkingLotSprite);
                }

                // Add hanging championships graphics
                if (match['hangingChampionships'] && match['hangingChampionships'].length > 0) {
                    let hangingChampionshipsMedian = getMedian(Array.from(Array(match['hangingChampionships'].length).keys()));
                    match['hangingChampionships'].forEach(function(hangingChampionship, hangingChampionshipIndex) {
                        let smallTitleData = getSmallTitleData(hangingChampionship);

                        // Go through small title parts
                        Object.keys(smallTitleData).forEach(function (key) {
                            let item = smallTitleData[key]['object'];
                            let newItem = smallTitleData[key]['object'];
                            item.designs.map(function (x, y) {
                                // Duplicate sprite
                                let newSprite = new PIXI.Sprite(x.sprite.texture);

                                // Add color
                                let spriteColor = smallTitleData[key]['colors'][y];
                                x.defaultColor = spriteColor; // change defaultColor
                                newSprite.tint = x.defaultColor;

                                // Add position
                                newSprite.zIndex = x.zIndex;
                                let xPos = (renderer.width / 2) - (newSprite.width / 2);
                                if (hangingChampionshipIndex > hangingChampionshipsMedian) {
                                    xPos += 42 * (hangingChampionshipIndex - hangingChampionshipsMedian)
                                }
                                else if (hangingChampionshipIndex < hangingChampionshipsMedian) {
                                    xPos -= 42 * (hangingChampionshipsMedian - hangingChampionshipIndex)
                                }
                                newSprite.position.x = xPos;
                                newSprite.position.y = -23;

                                // Add to stage
                                newSprite.parentLayer = layer;
                                stageObjects.addChild(newSprite);

                                // Set new sprite to duplicate object
                                newItem.designs[y].sprite = newSprite;
                            });
                        })
                    });
                }
            }

            if (match && match['annualTournament']) {
                if (match['name'] === 'Trophy Presentation') {

                    // Add trophy graphic
                    sprites.TGITrophy.parentLayer = layer;
                    sprites.TGITrophy.y = -10;
                    sprites.TGITrophy.zIndex = 40;
                    stageObjects.addChild(sprites.TGITrophy);

                    if (segmentAction) {
                        // Add fireworks graphic
                        sprites.TGIFireworks.parentLayer = layer;
                        sprites.TGIFireworks.x = 0;
                        sprites.TGIFireworks.y = 0;
                        sprites.TGIFireworks.zIndex = 40;
                        stageObjects.addChild(sprites.TGIFireworks);

                        // Position trophy next to winner
                        sprites.TGITrophy.x = 96;
                    }
                    else {
                        // Position trophy next to president
                        sprites.TGITrophy.x = 241;

                    }
                }
            }

            renderer.render(stage);
        }

        function selectGimmickMatchWeaponObject(seed) {

            // Seed random
            let newMathRandom = new Math.seedrandom(seed);

            // Get object by weights
            let weaponObjectWeights = [3, 5, 3, 3, 3, 1, 3, 3, 1, 1, 3, 3, 3, 3, 3, 3, 1];
            let selectedWeaponObject = pickUsingWeights(sprites.weaponObjects, weaponObjectWeights, newMathRandom());

            // Get object color
            let objectColors;
            // Kendo stick
            if (selectedWeaponObject === sprites.accessoryObject25) {
                objectColors = getRandomChoice([['0xE8D68A', '0xE8E7E7'], ['0xC0A15D', '0xCDCDCD']], newMathRandom())
            }
            // Steel chair
            else if (selectedWeaponObject === sprites.accessoryObject29) {
                objectColors = getRandomChoice([['0x4C4C4C'], ['0x6A83B0'], ['0xA1A1A1'], ['0xB7AA86']], newMathRandom())
            }
            // Sledgehammer
            else if (selectedWeaponObject === sprites.accessoryObject30) {
                objectColors = getRandomChoice([['0xCCA670', '0x4D4D4D'], ['0x957A4C', '0x7F7A73']], newMathRandom())
            }
            // Barbed wire bat
            else if (selectedWeaponObject === sprites.accessoryObject31) {
                objectColors = getRandomChoice([['0xD9BA5B', '0xD2D2D2'], ['0xA48040', '0x4C4C4C']], newMathRandom())
            }
            // Crutch
            else if (selectedWeaponObject === sprites.accessoryObject41) {
                objectColors = getRandomChoice([['0xCCCCCC', '0x969696', '0xE5564D'], ['0x575757', '0x3B3B3B', '0x575757']], newMathRandom())
            }
            // Hockey stick
            else if (selectedWeaponObject === sprites.accessoryObject45) {
                objectColors = getRandomChoice([['0xD1D1D1', '0xD1B78A'], ['0x474747', '0xCF7738']], newMathRandom())
            }
            // Light tube
            else if (selectedWeaponObject === sprites.accessoryObject47) {
                objectColors = getRandomChoice([['0xE0E0E0', '0x8D8D8D'], ['0xC7DBE8', '0x8D8D8D'], ['0xEAE2B2', '0x8D8D8D']], newMathRandom())
            }
            // Baseball bat
            else if (selectedWeaponObject === sprites.accessoryObject49) {
                objectColors = getRandomChoice([['0xC6A26B'], ['0x474747'], ['0xE8C090']], newMathRandom())
            }
            // Tennis racket
            else if (selectedWeaponObject === sprites.accessoryObject52) {
                objectColors = getRandomChoice([['0x3E3E3E', '0x9D272B', '0x505050'], ['0xE8E4E4', '0xACD128', '0xA2A2A2'],
                    ['0xDCDCDC', '0x383838', '0xBBB5B5'], ['0x4D94A1', '0xD7D7D7', '0xA1A1A1']], newMathRandom())
            }
            // Guitar
            else if (selectedWeaponObject === sprites.accessoryObject53) {
                objectColors = getRandomChoice([['0xFFDA94', '0x755B3D', '0x423A30', '0xFFFFFF'],
                    ['0x0D0D0D', '0x0D0D0D', '0x0D0D0D', '0x999999'], ['0xDEB546', '0x524221', '0x423A30', '0xFFFFFF']], newMathRandom())
            }
            // Bag
            else if (selectedWeaponObject === sprites.accessoryObject55) {
                objectColors = getRandomChoice([['0x555555'], ['0xD9CDC4']], newMathRandom())
            }
            // Trash can
            else if (selectedWeaponObject === sprites.accessoryObject56) {
                objectColors = getRandomChoice([['0xD4D8DB'], ['0xB2BBB5'], ['0x73787F']], newMathRandom())
            }
            // Stop sign
            else if (selectedWeaponObject === sprites.accessoryObject57) {
                objectColors = getRandomChoice([['0xAE2D2D', '0xE8E8E8', '0xD9D9D9'], ['0xE6D434', '0x333333', '0x333333'],
                    ['0x1C4AC0', '0xE8E8E8', '0xD9D9D9']], newMathRandom())
            }
            // Shovel
            else if (selectedWeaponObject === sprites.accessoryObject58) {
                objectColors = getRandomChoice([['0x957F5F', '0x656565'], ['0x675F4E', '0xB0B0B0'], ['0xC6AB33', '0xE4C643']], newMathRandom())
            }
            // Fire extinguisher
            else if (selectedWeaponObject === sprites.accessoryObject59) {
                objectColors = getRandomChoice([['0xC2493A', '0xEBEBEB', '0x565656', '0xBEBEBE'],
                    ['0xC2493A', '0xEFE425', '0xACACAC', '0xA23D31']], newMathRandom())
            }
            // Chainsaw
            else if (selectedWeaponObject === sprites.accessoryObject72) {
                objectColors = getRandomChoice([['0xD95C2B', '0xE3E4E4', '0xD95C2B', '0x525252'],
                    ['0x6C6C6C', '0xE3E4E4', '0xE8DB33', '0x4A4A4A'],
                    ['0xD5532A', '0xDBE0E4', '0xC8C8C8', '0x4A4A4A']], newMathRandom())
            }
            // Flaming 2x4
            else {
                objectColors = selectedWeaponObject.designs.map(function (x) {
                    return x.defaultColor;
                });
            }

            return {
                object: sprites.weaponObjects.indexOf(selectedWeaponObject),
                colors: objectColors
            }
        }

        function getSmallTitleData(titleData) {
            // Get small objects using center plate
            let centerPlateObject = sprites.centerPlates[titleData['centerPlate']['object']];
            let smallPlateObject = centerPlateObject.smallPlateObject;
            let smallStrapObject = smallPlateObject.smallStrapObject;
            let smallGemsObject = smallPlateObject.smallGemsObject;

            // Create small title data
            let smallTitleData = {};
            smallTitleData.smallPlateObject = {
                'object': smallPlateObject,
                'colors': titleData['centerPlate']['colors']
            };
            smallTitleData.smallStrapObject = {
                'object': smallStrapObject,
                'colors': titleData['strap']['colors']
            };
            smallTitleData.smallGemsObject = {
                'object': smallGemsObject,
                'colors': titleData['centerGems']['colors']
            };

            return smallTitleData;
        }

        // Update design selection
        function updateDesigns(object) {
            let element = el.siblings('.part-controls').find('.select-design button');

            if (object.designs.length > 1) {
                element.each(function (index) {
                    if (index === 0) {
                        $(this).addClass('selected')
                    } else {
                        $(this).removeClass('selected')
                    }
                    if (index < object.designs.length) {
                        $(this).show()
                    }
                    else {
                        $(this).hide()
                    }
                });
            }
            else {
                element.hide();
            }

            // Update color selection
            let i = element.index(element.eq(0).parent().find('.selected:visible'));
            let color;
            if (i < 0) {
                i = 0
            }

            color = selected.designs[i].defaultColor.slice(2);
            el.siblings('.part-controls').find('.spectrum').spectrum('set', color);
        }

        function getSubCategorySelections(parentCategory, subCategory) {
            let selections;
            switch (parentCategory) {
                case 'Hair':
                    switch (subCategory) {
                        case 'Short':
                            selections = sprites.shortHair;
                            break;
                        case 'Long':
                            selections = sprites.longHair;
                            break;
                        case 'Feminine':
                            selections = sprites.feminineHair;
                            break;
                    }
                    break;
                case 'Shoes':
                    switch (subCategory) {
                        case 'Long':
                            selections = sprites.longShoes;
                            break;
                        case 'Short':
                            selections = sprites.shortShoes;
                            break;
                    }
                    break;
                case 'Torso':
                    switch (subCategory) {
                        case 'Shirt':
                            selections = sprites.shirtTops;
                            break;
                        case 'Vest':
                            selections = sprites.vestTops;
                            break;
                        case 'Sports Bra':
                            selections = sprites.sportsBraTops;
                            break;
                        case 'Feminine':
                            selections = sprites.feminineTops;
                            break;
                        case 'Other':
                            selections = sprites.otherTops;
                            break;
                    }
                    break;
                case 'Bottoms':
                    switch (subCategory) {
                        case 'Tights':
                            selections = sprites.tights;
                            break;
                        case 'Trunks':
                            selections = sprites.trunks;
                            break;
                        case 'Shorts':
                            selections = sprites.shorts;
                            break;
                        case 'Feminine':
                            selections = sprites.feminineBottoms;
                            break;
                    }
                    break;
                case 'Accessory':
                    switch (subCategory) {
                        case 'Gloves':
                            selections = sprites.glovesAccessories;
                            break;
                        case 'Wrist Tape':
                            selections = sprites.wristTapeAccessories;
                            break;
                        case 'Glasses':
                            selections = sprites.glassesAccessories;
                            break;
                        case 'Suit & Tie':
                            selections = sprites.suitAndTieAccessories;
                            break;
                        case 'Feminine':
                            selections = sprites.feminineAccessories;
                            break;
                        case 'Neck':
                            selections = sprites.neckAccessories;
                            break;
                        case 'Weapons':
                            selections = sprites.weaponObjects;
                            break;
                         case 'Masks':
                            selections = sprites.masksAccessories;
                            break;
                        case 'Flags':
                            selections = sprites.flagsAccessories;
                            break;
                        case 'Other':
                            selections = sprites.otherAccessories;
                            break;
                    }
                    break;
            }
            return selections;
        }

        function setSelectedPartForSubCategory(parentCategory, selection, accessoryNumber) {
            switch (parentCategory) {
                case 'Accessory':
                    selectedAccessory = selection;
                    // Save to accessory number
                    switch (accessoryNumber) {
                        case '1':
                            addedAccessory = selection;
                            break;
                        case '2':
                            addedAccessory2 = selection;
                            break;
                        case '3':
                            addedAccessory3 = selection;
                            break;
                        default:
                            addedAccessory = selection;
                    }
                    break;
                case 'Hair':
                    addedHair = selection;
                    break;
                case 'Bottoms':
                    addedBottoms = selection;
                    break;
                case 'Torso':
                    addedTorso = selection;
                    break;
                case 'Shoes':
                    addedShoes = selection;
                    break;
            }
            selected = selection;
            return true;
        }
    }
}

function loadBaseAttire() {
    // Select attire "A"
    $('.attire-select-button.selected').removeClass('selected');
    $('.attire-select-button:contains("A")').addClass('selected');
    $('.part-button.disabled').removeClass('disabled');
    $('.remove-attire-button').hide();
}

function loadTitleGraphic(stage, stageObjects, stageLayers, stageBackground, layer, jsonData, el, showPalette) {

    if (typeof(showPalette) === 'undefined') showPalette = true;
    if (typeof(jsonData) === 'undefined') jsonData = null;
    if (typeof(el) === 'undefined' || el === null) {
        el = $('.select-part')
    }
    else {
        el = el.siblings('.character-creator-controls').find('.select-part')
    }

    // Run setup if resources loaded, otherwise wait for load event (first time)
    PIXI.loader.on('complete', function () {
        resourcesLoaded = true;
    });
    if (resourcesLoaded) {
        // Unbind click handlers
        $('.character-creator-controls *').off();
        setup();
    }
    else {
        PIXI.loader.load(setup);
    }

    function setup() {

        // Initialize spectrum color picker
        if (showPalette) {
            el.next('.part-controls').find(".spectrum").spectrum({
                showPalette: true,
                palette: [
                    ["#000", "#444", "#666", "#999", "#ccc", "#eee", "#f3f3f3", "#fff"],
                    ["#f00", "#f90", "#ff0", "#0f0", "#0ff", "#00f", "#90f", "#f0f"],
                    ["#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#d9d2e9", "#ead1dc"],
                    ["#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#b4a7d6", "#d5a6bd"],
                    ["#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8e7cc3", "#c27ba0"],
                    ["#c00", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3d85c6", "#674ea7", "#a64d79"],
                    ["#900", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#0b5394", "#351c75", "#741b47"],
                    ["#600", "#783f04", "#7f6000", "#274e13", "#0c343d", "#073763", "#20124d", "#4c1130"],
                    ["#C59548", "#DDA240", "#D9B04D", "#D7A018", "#EABF3E", "#C69F29", "#C1B76B", "#F6CDCE"],
                    ["#D99352", "#B7641C", "#E5E6EA", "#BABABA"]
                ],
                preferredFormat: "hex",
                color: "#C59548",
                showInitial: true,
                showInput: true,
                showButtons: false
            });
        }

        $('.add-championship-container').find('.sp-replacer').addClass('grey-background');

        const sprites = loadTitleSprites();

        /*
        // GENERATE JSON FOR GENERATING GRAPHICS ON BACK END

        function getDesignsLength(x, i) {
            let y = {};
            y['designs'] = x['designs'].length;

            if (x && x.designs[0].sprite === emptySprite) {
                i = -1
            }
            y['number'] = i;

            if (allCenterPlates.indexOf(x) >= 0) {
                y['gemPart'] = allCenterGems.indexOf(x.gemPart);
                y['strapPart'] = allStraps.indexOf(x.strapPart);
                y['sidePlatesPart'] = allSidePlates.indexOf(x.sidePlatesPart);
            }
            else {
                y['sideGemsPart'] = allSideGems.indexOf(x.sideGemsPart);
            }

            return y;
        }

        let allCenterPlates = Array.from(allCenterPlates, getDesignsLength);
        let allSidePlates = Array.from(allSidePlates, getDesignsLength);
        let allParts = {
            'centerPlate': allCenterPlates,
            'sidePlates': allSidePlates
        };
        console.log(JSON.stringify(allParts));*/

        let parts = {
            'centerPlate': sprites.allCenterPlates,
            'strap': sprites.allStraps,
            'sidePlates': sprites.allSidePlates,
            'centerGems': sprites.allCenterGems,
            'sideGems': sprites.allSideGems
        };
        let selected;
        let selectedPart;
        let selections = sprites.centerPlates;

        // Check for loaded data
        let data = jsonData;
        let addedCenterPlate;
        let addedStrap;
        let addedSidePlates;
        let addedCenterGems;
        let addedSideGems;
        let addedParts = {
            'centerPlate': addedCenterPlate, 'strap': addedStrap, 'sidePlates': addedSidePlates,
            'centerGems': addedCenterGems, 'sideGems': addedSideGems
        };
        let allowChange;

        if (!data) {
            // Add default character
            addedCenterPlate = sprites.centerPlates[0];
            addedStrap = sprites.straps[0];
            addedSidePlates = sprites.sidePlates[0];
            addedCenterGems = sprites.centerGems[0];
            addedSideGems = sprites.sideGems[0];

            // Add parts to stage, set colors and zIndex
            addedCenterPlate.designs.map(function (x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });

            addedStrap.designs.map(function (x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });

            addedSidePlates.designs.map(function (x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });

            addedCenterGems.designs.map(function (x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });

            addedSideGems.designs.map(function (x) {
                x.sprite.parentLayer = layer;
                x.sprite.zIndex = x.zIndex;
                x.sprite.tint = x.defaultColor;
                stageObjects.addChild(x.sprite);
            });

            updateCenterPlateParts(addedCenterPlate);

            // Allow randomization
            allowChange = true;
        }
        else {
            // Load graphic
            loadGraphicFromCode(data);

            // Update center plate parts but don't replace
            updateCenterPlateParts(addedCenterPlate, false);

            // Don't allow randomization after loading character
            allowChange = false;
        }

        renderer.render(stage);

        // Change style
        let x = 0;
        let selectedElement = $('.add-championship-container, #change-championship-graphic-container, ' +
            '.custom-starting-company-championships, .scenario-editor-container, .form-new-company-championships');
        selectedElement.off().on('click', '.select-next, .select-previous', function () {

            allowChange = false;
            let $this = $(this);

            // Replace existing part
            if (selections.indexOf(selected) !== -1) {
                selected.designs.map(function (x) {
                    stageObjects.removeChild(x.sprite);
                })
            }

            // Next and previous selection
            if ($this.hasClass('select-previous')) {
                x--
            }
            else {
                x++
            }

            // Stay within selections
            if (x === selections.length) {
                x = 0
            }
            if (x < 0) {
                x = selections.length - 1
            }

            // Select and display part (add to layer for z index sorting)
            selected = selections[x];
            if (selections.indexOf(selected) !== -1) {
                selected.designs.map(function (x) {
                    stageObjects.addChild(x.sprite);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.sprite.tint = x.defaultColor;
                })
            }

            renderer.render(stage);

            // Store selected part and alter positioning if needed
            if (sprites.centerPlates.indexOf(selected) !== -1) {
                addedCenterPlate = selected;
                // Update center plate's parts (strap, gems)
                updateCenterPlateParts(addedCenterPlate);
            }
            else if (sprites.straps.indexOf(selected) !== -1) {
                addedStrap = selected;
            }
            else if (sprites.sidePlates.indexOf(selected) !== -1) {
                addedSidePlates = selected;
                updateSidePlatesParts(addedSidePlates);
            }
            else if (sprites.centerGems.indexOf(selected) !== -1) {
                addedCenterGems = selected;
            }
            else if (sprites.sideGems.indexOf(selected) !== -1) {
                addedSideGems = selected;
            }

            // Update selection number
            $this.parent().find('.selection-number').text(x + 1);


            // Update positions of parts based on size
            updateDesigns(selected);

        });

        // Select part to edit
        selectedElement.on("click", ".part-button", function () {

            // Hide share/import
            $(this).parent().siblings('.load-character-code-container').hide();
            $(this).parent().siblings('.share-character-code-container').hide();
            $(this).parent().siblings('.character-creator-menu').find('.button').removeClass('selected');

            let $this = $(this);
            $(this).addClass('selected');
            $(this).parent().children().each(function () {
                if (!($(this).is($this))) {
                    $(this).removeClass('selected')
                }
            });
            selectedPart = $(this).text().trim().toLowerCase();

            switch ($(this).text().trim()) {
                case 'Center Plate':
                    selections = sprites.centerPlates;
                    if (addedCenterPlate) {
                        x = selections.indexOf(addedCenterPlate);
                        selected = addedCenterPlate;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
                case 'Strap':
                    selections = sprites.straps;
                    if (addedStrap) {
                        x = selections.indexOf(addedStrap);
                        selected = addedStrap;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
                case 'Side Plates':
                    selections = sprites.sidePlates;
                    if (addedSidePlates) {
                        x = selections.indexOf(addedSidePlates);
                        selected = addedSidePlates;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
                case 'Center Gems':
                    selections = sprites.centerGems;
                    if (addedCenterGems) {
                        x = selections.indexOf(addedCenterGems);
                        selected = addedCenterGems;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
                case 'Side Gems':
                    selections = sprites.sideGems;
                    if (addedSideGems) {
                        x = selections.indexOf(addedSideGems);
                        selected = addedSideGems;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(x + 1);
                        updateDesigns(selected);
                    }
                    else {
                        x = -1;
                        $(this).parent().siblings('.part-controls').find('.selection-number').text(0);
                        // Hide design selection if no design selected
                        $(this).parent().siblings('.part-controls').find('.select-design .button').hide();
                    }
                    break;
            }

        });

        // Select design to recolor
        selectedElement.on('click', '.select-design .button', function () {
            let $this = $(this);
            $(this).addClass('selected');
            $this.parent().children().each(function () {
                if (!($(this).is($this))) {
                    $(this).removeClass('selected')
                }
            });

            // Update color selection
            let i = $this.parent().children().index($this);
            if (i >= 0) {
                let color = selected.designs[i].defaultColor.slice(2);
                $this.parent().parent().prev().find('.spectrum').spectrum('set', color);
            }
        });

        // Change color
        selectedElement.on('move.spectrum change', '.spectrum', function (e, tinycolor) {
            if (selected) {
                allowChange = false;
                let selectDesign = $(this).parent().siblings('.select-design-holder').children('.select-design');

                // Convert color to hexadecimal
                let colorString = tinycolor.toHexString();
                let color = '0x' + colorString.slice(1);
                // Find which design is selected
                let i;
                if (selectDesign.find('.selected:visible').length > 0) {
                    i = selectDesign.find('button').index(selectDesign.find('.selected'));
                } else {
                    i = 0
                }

                selected.designs[i].sprite.tint = color;
                // Change default color, saving selected color
                selected.designs[i].defaultColor = color;
                renderer.render(stage);
            }
        });

        // Save graphic
        selectedElement.on('click', '.share-character', function () {

            function getObject(object, objects) {
                let objectIndex;
                // Don't add object if empty sprite
                if (object && object.designs[0].sprite === sprites.emptySprite) {
                    objectIndex = -1
                }
                else {
                    objectIndex = objects.indexOf(object)
                }
                return {
                    object: objectIndex,
                    colors: (object) ? object.designs.map(function (x) {
                        return x.defaultColor;
                    }) : null
                }
            }

            let data = {
                centerPlate: getObject(addedCenterPlate, sprites.allCenterPlates),
                strap: getObject(addedStrap, sprites.allStraps),
                sidePlates: getObject(addedSidePlates, sprites.allSidePlates),
                centerGems: getObject(addedCenterGems, sprites.allCenterGems),
                sideGems: getObject(addedSideGems, sprites.allSideGems)
            };
            jsonData = JSON.stringify(data);

            // Show code and copy button
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).parent().siblings('.share-character-code-container').hide();
            }
            else {
                $(this).siblings().removeClass('selected');
                $(this).addClass('selected');
                $(this).parent().siblings('.share-character-code-container').show();
                $(this).parent().siblings('.share-character-code-container')
                    .children('.share-character-code-input').val(jsonData).text(jsonData);
                $(this).parent().siblings('.load-character-code-container').hide();
            }
        });

        // Copy graphic code
        selectedElement.on('click', '.copy-character-code', function () {
            $(this).parent().siblings('.character-creator-menu').find('.share-character').trigger('click');
            copyToClipboard($(this).siblings('.share-character-code-input'));
        });

        // Import graphic
        selectedElement.on('click', '.import-character', function () {
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).parent().siblings('.load-character-code-container').hide();
            }
            else {
                $(this).siblings().removeClass('selected');
                $(this).addClass('selected');
                // Show input and load button
                $(this).parent().siblings('.load-character-code-container').show();
                $(this).parent().siblings('.share-character-code-container').hide();
            }
        });

        // Load graphic code
        selectedElement.on('click', '.load-character-code-button', function () {
            let data = $(this).siblings('.load-character-code-input').val();
            let rebrandChampionship = $(this).closest('#change-championship-graphic-container').length > 0;
            if (!data) {
                notie.alert({type: 3, text: 'Invalid graphic code', stay: false});
            }
            else {
                try {
                    let graphicData = JSON.parse(data);
                    loadGraphicFromCode([graphicData]);
                    // Update center plate's parts but don't replace
                    updateCenterPlateParts(addedCenterPlate, false);
                    $(this).parent().siblings('.character-creator-menu').find('.import-character').removeClass('selected');
                    $(this).parent('.load-character-code-container').hide();
                    if (!rebrandChampionship) {
                        notie.alert({type: 4, text: 'Graphic loaded!', stay: false})
                    }
                }
                catch (e) {
                    captureError(e)
                    notie.alert({type: 3, text: 'Invalid graphic code', stay: false});
                }
            }
        });

        // Randomize graphic menu
        selectedElement.on('click', '.randomize-character', function () {

            function randomizeGraphic() {
                // Reset stage
                while (stageObjects.children[0]) {
                    stageObjects.removeChild(stageObjects.children[0]);
                }
                while (stageLayers.children[0]) {
                    stageLayers.removeChild(stageLayers.children[0]);
                }

                // Select center plate and its parts
                addedCenterPlate = getRandomChoice(sprites.centerPlates);
                addedStrap = addedCenterPlate.strapPart;
                addedCenterGems = addedCenterPlate.gemPart;

                // Select side plates and its parts
                if (getRandomInt(0, 100) <= 70) {
                    addedSidePlates = addedCenterPlate.sidePlatesPart
                }
                else {
                    addedSidePlates = getRandomChoice(sprites.sidePlates)
                }
                addedSideGems = addedSidePlates.sideGemsPart;

                // Get part colors
                let centerPlateColor = getPlateColor();
                let sidePlatesColor = centerPlateColor;
                if (getRandomInt(0, 100) <= 5) {
                    sidePlatesColor = getPlateColor();
                }
                let strapColor = getStrapColor();
                let centerGemsColor = getGemsColor();
                let sideGemsColor = centerGemsColor;
                if (getRandomInt(0, 100) <= 5) {
                    sideGemsColor = getGemsColor();
                }

                // Add parts to stage

                addedCenterPlate.designs.map(function (x) {
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = centerPlateColor;
                    x.sprite.tint = centerPlateColor;
                    stageObjects.addChild(x.sprite);
                });

                addedStrap.designs.map(function (x) {
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = strapColor;
                    x.sprite.tint = strapColor;
                    stageObjects.addChild(x.sprite);
                });

                addedSidePlates.designs.map(function (x) {
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = sidePlatesColor;
                    x.sprite.tint = sidePlatesColor;
                    stageObjects.addChild(x.sprite);
                });

                addedCenterGems.designs.map(function (x) {
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = centerGemsColor;
                    x.sprite.tint = centerGemsColor;
                    stageObjects.addChild(x.sprite);
                });

                addedSideGems.designs.map(function (x) {
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.defaultColor = sideGemsColor;
                    x.sprite.tint = sideGemsColor;
                    stageObjects.addChild(x.sprite);
                });

                // Update parts
                sprites.straps = [addedCenterPlate.strapPart];
                sprites.centerGems = [addedCenterPlate.gemPart, sprites.emptyCenterGemsObject];
                sprites.sideGems = [addedSidePlates.sideGemsPart, sprites.emptySideGemsObject];

                el.find('.button').eq(0).trigger('click');

                renderer.render(stage);
            }

            // Randomize instantly if no parts changed
            if (allowChange) {
                randomizeGraphic();
            }
            // Otherwise notie alert asking to confirm
            else {
                notie.confirm({
                    text: 'Are you sure?',
                    submitCallback: function () {
                        randomizeGraphic();
                        allowChange = true;
                    }
                });
            }
        });

        // Select center plate button initially
        el.find('.button').eq(0).trigger('click');

        // Load graphic
        function loadGraphicFromCode(data) {

            // Reset stage
            while (stageObjects.children[0]) {
                stageObjects.removeChild(stageObjects.children[0]);
            }
            while (stageLayers.children[0]) {
                stageLayers.removeChild(stageLayers.children[0]);
            }

            // Background
            if (characterBackgroundImage) {
                let background = PIXI.Sprite.fromImage(characterBackgroundImage);
                background.zIndex = -100;
                stageBackground.addChild(background);
            }

            data.forEach(function (characterData, i) {

                let characterContainer = new PIXI.Container();

                Object.keys(addedParts).forEach(function (key, index) {

                    // Get object by part key
                    let partData = characterData[key];
                    if (partData && partData['object'] >= 0) {
                        let objectIndex = characterData[key]['object'];
                        let item = parts[key][objectIndex]; // get object
                        let newItem = parts[key][objectIndex]; // duplicate object

                        item.designs.map(function (x, y) {
                            // Duplicate sprite
                            let newSprite = new PIXI.Sprite(x.sprite.texture);

                            // Add color
                            let spriteColor = characterData[key]['colors'][y];
                            if (!spriteColor) {
                                // For backwards compatibility with new designs added to part (e.g hair streak)
                                // Set color to previous design's color if not found
                                spriteColor = characterData[key]['colors'][y - 1];
                            }
                            x.defaultColor = spriteColor; // change defaultColor
                            newSprite.tint = x.defaultColor;

                            // Add parts to stage
                            newSprite.parentLayer = layer;
                            newSprite.zIndex = x.zIndex;

                            // Get x position of character
                            newSprite.position.x = x.sprite.position.x;

                            newSprite.position.y = x.sprite.position.y;
                            characterContainer.addChild(newSprite);
                            stageObjects.addChild(newSprite);

                            // Set new sprite to duplicate object
                            newItem.designs[y].sprite = newSprite;
                        });

                        addedParts[key] = newItem;
                    }
                    else {
                        addedParts[key] = null
                    }
                });
            });

            // Set added parts
            addedCenterPlate = addedParts['centerPlate'];
            addedStrap = addedParts['strap'];
            addedSidePlates = addedParts['sidePlates'];
            addedCenterGems = addedParts['centerGems'];
            addedSideGems = addedParts['sideGems'];

            // Add empty objects if null
            if (!addedSidePlates) {
                addedSidePlates = sprites.emptySidePlatesObject
            }
            if (!addedCenterGems) {
                addedCenterGems = sprites.emptyCenterGemsObject
            }
            if (!addedSideGems) {
                addedSideGems = sprites.emptySideGemsObject
            }

            if (!selected) {
                // Select center plate upon initial load
                selected = addedCenterPlate
            }
            else {
                // Add selected part again because it changed
                selected = addedParts['centerPlate'];
            }
            // Select center plate button
            el.find('.button').eq(0).trigger('click');

            // Update part controls
            let x = selections.indexOf(selected);
            $('.selection-number').text(x + 1);
            updateDesigns(selected);
            renderer.render(stage);
        }

        // Update design selection
        function updateDesigns(object) {
            let element = el.siblings('.part-controls').find('.select-design button');

            if (object.designs.length > 1) {
                element.each(function (index) {
                    if (index === 0) {
                        $(this).addClass('selected')
                    } else {
                        $(this).removeClass('selected')
                    }
                    if (index < object.designs.length) {
                        $(this).show()
                    }
                    else {
                        $(this).hide()
                    }
                });
            }
            else {
                element.hide();
            }

            // Update color selection
            let i = element.index(element.eq(0).parent().find('.selected:visible'));
            let color;
            if (i < 0) {
                i = 0
            }

            color = selected.designs[i].defaultColor.slice(2);
            el.siblings('.part-controls').find('.spectrum').spectrum('set', color);
        }

        // Update strap and gems for center plate change
        function updateCenterPlateParts(centerPlate, replace) {

            // Set to false for loading graphic, so parts not replaced by defaults
            if (typeof(replace) === 'undefined') replace = true;

            // Update gems and straps to center plate's only
            sprites.straps = [centerPlate.strapPart];
            sprites.centerGems = [centerPlate.gemPart, sprites.emptyCenterGemsObject];

            // Replace side plates if added
            if (replace) {
                addedSidePlates.designs.map(function (x) {
                    stageObjects.removeChild(x.sprite);
                });

                // Keep all side plates, set to center plate's default one
                addedSidePlates = centerPlate.sidePlatesPart;

                addedSidePlates.designs.map(function (x) {
                    stageObjects.addChild(x.sprite);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.sprite.tint = x.defaultColor;
                })
            }

            // Replace center gems if added
            if (replace) {
                addedCenterGems.designs.map(function (x) {
                    stageObjects.removeChild(x.sprite);
                });

                addedCenterGems = sprites.centerGems[0];

                addedCenterGems.designs.map(function (x) {
                    stageObjects.addChild(x.sprite);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.sprite.tint = x.defaultColor;
                })
            }

            // Replace strap
            if (replace) {
                addedStrap.designs.map(function (x) {
                    stageObjects.removeChild(x.sprite);
                });
                addedStrap = sprites.straps[0];
                addedStrap.designs.map(function (x) {
                    stageObjects.addChild(x.sprite);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.sprite.tint = x.defaultColor;
                })
            }

            if (addedSidePlates) {
                updateSidePlatesParts(addedSidePlates, replace);
            }

            renderer.render(stage);
        }

        // Update gems for side plates change
        function updateSidePlatesParts(sidePlates, replace) {
            if (typeof(replace) === 'undefined') replace = true;

            // Update side gems side plate's only
            sprites.sideGems = [sidePlates.sideGemsPart, sprites.emptySideGemsObject];

            // Remove existing part
            if (replace) {
                addedSideGems.designs.map(function (x) {
                    stageObjects.removeChild(x.sprite);
                });
                addedSideGems = sprites.sideGems[0];

                // Display new parts
                addedSideGems.designs.map(function (x) {
                    stageObjects.addChild(x.sprite);
                    x.sprite.parentLayer = layer;
                    x.sprite.zIndex = x.zIndex;
                    x.sprite.tint = x.defaultColor;
                });
                renderer.render(stage);
            }
        }
    }
}

function getPlateColor() {
    let colorsA = ["#C59548", "#DDA240", "#D9B04D", "#D7A018", "#EABF3E", "#C69F29", "#C1B76B"];
    let colorsB = ["#F6CDCE", "#D99352", "#B7641C", "#E5E6EA", "#BABABA"];
    let centerPlateColor;
    let pick = getRandomInt(0, 100);

    if (pick <= 70) {
        centerPlateColor = getRandomChoice(colorsA)
    }
    else if (pick <= 95) {
        centerPlateColor = getRandomChoice(colorsB)
    }
    else {
        centerPlateColor = getRandomColor()
    }

    return '0x' + centerPlateColor.slice(1);
}


function getStrapColor() {
    let colorsA = ["#1D1D1D"];
    let colorsB = ["#981E21", "#2F4F7D", "#E5E5E5", "#2F6232", "#83264F", "#3B2363"];
    let strapColor;
    let pick = getRandomInt(0, 100);

    if (pick <= 70) {
        strapColor = getRandomChoice(colorsA)
    }
    else if (pick <= 95) {
        strapColor = getRandomChoice(colorsB)
    }
    else {
        strapColor = getRandomColor()
    }

    return '0x' + strapColor.slice(1);
}


function getGemsColor() {
    let colorsA = ["#001E97", "#148A0D", "#C51616", "#CA0F68", "#F4DE39", "#BD1DAC", "#EFEFF0"];
    let gemsColor;
    let pick = getRandomInt(0, 100);

    if (pick <= 80) {
        gemsColor = getRandomChoice(colorsA)
    }
    else {
        gemsColor = getRandomColor()
    }

    return '0x' + gemsColor.slice(1);
}

function getRandomColor() {
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

function copyToClipboard(element, value, text) {
    let val = (element) ? ($(element).text()) : value;
    let $temp = $("<input>");
    $("body").append($temp);
    $temp.val(val).select();
    document.execCommand("copy");
    $temp.remove();

    let notieText = (text) ? (text) : 'Copied to clipboard!';
    notie.alert({type: 4, text: notieText, stay: false});
}

function chunk(arr, len) {
    let chunks = [],
        i = 0,
        n = arr.length;
    while (i < n) {
        chunks.push(arr.slice(i, i += len));
    }
    return chunks;
}

function getMedian(numbers) {
    // median of [3, 5, 4, 4, 1, 1, 2, 3] = 3
    let median = 0, numsLen = numbers.length;
    numbers.sort();

    if (
        numsLen % 2 === 0 // is even
    ) {
        // average of two middle numbers
        median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2;
    } else { // is odd
        // middle number only
        median = numbers[(numsLen - 1) / 2];
    }

    return median;
}

function getEqualChunkSize(length) {
    let rows = Math.ceil(length / 10);
    return Math.ceil(length / rows);
}

function addCharacterCreatorSubCategory(subCategories, characterCreatorElement) {
    let html = '';
    subCategories.forEach(function (subCategory) {
        html += '<button type="button" class="button retro-button condensed grey-button-background remove-outline sub-category-button">' +
            subCategory + '</button>\n'
    });
    characterCreatorElement.find('.select-sub-category').html(html);
    return html
}

function showEventPosterPageGraphic(data, parentElement) {
    if (data && data['graphics'].length > 0) {
        // Create the renderer
        if (renderer) {
            renderer.destroy()
        }
        renderer = PIXI.autoDetectRenderer(475, 645);
        renderer.autoResize = true;

        // Create stage and add a layer
        stage = new PIXI.display.Stage();
        let stageObjects = new PIXI.Container();
        let stageLayers = new PIXI.Container();
        let stageBackground = new PIXI.Container();
        stage.addChild(stageBackground);
        stage.addChild(stageObjects);
        stage.addChild(stageLayers);
        let layer = new PIXI.display.Layer();
        layer.group.enableSort = true;
        stage.addChild(layer);

        // Render the stage
        renderer.backgroundColor = 0x222222;
        renderer.view.style.position = "relative";
        renderer.view.style.display = "block";
        renderer.render(stage);
        let el = parentElement.find('.event-poster-graphic');
        el.html('');
        el.append(renderer.view);

        loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, data['graphics'],
            {'type': 'singles'}, el, false, true, data);

        parentElement.fadeIn();

        // Download event poster
        parentElement.off('click', '.event-poster-download-button');
        parentElement.on('click', '.event-poster-download-button', function () {
            stage.removeChild(stageBackground);
            let fileName = '{0} {1} Poster.png'.format(data['eventName'], data['eventYear']);

            // Create texture from renderer's dimensions to crop anything outside it
            let downloadTexture = PIXI.RenderTexture.create(renderer.width, renderer.height);
            renderer.render(stage, downloadTexture);

            downloadSprite(renderer, downloadTexture, fileName);
        });
    }
}


function downloadSprite(renderer, sprite, fileName) {
    renderer.extract.canvas(sprite).toBlob(function(b){
		let a = document.createElement('a');
		document.body.append(a);
		a.download = fileName;
		a.href = URL.createObjectURL(b);
		a.click();
		a.remove();
	}, 'image/png');
}

function resetMatchGraphics() {
    const $match = $('#match');

    // Reset renderer
    if (renderer) {
            renderer.destroy()
        }
    renderer = PIXI.autoDetectRenderer(434, 300);
    renderer.autoResize = true;
    $('#match-graphics').remove();

    // Add the canvas to the HTML document
    let el = $('<div id="match-graphics" class="margin-bottom-20"></div>');
    el.append(renderer.view);
    $match.prepend(el).hide();

    // Create stage and add a layer
    stage = new PIXI.display.Stage();
    let stageObjects = new PIXI.Container();
    let stageLayers = new PIXI.Container();
    let stageBackground = new PIXI.Container();
    stage.addChild(stageBackground);
    stage.addChild(stageObjects);
    stage.addChild(stageLayers);
    let layer = new PIXI.display.Layer();
    layer.group.enableSort = true;
    stage.addChild(layer);

    // Background
    if (characterBackgroundImage) {
        let background = PIXI.Sprite.fromImage(characterBackgroundImage);
        background.zIndex = -100;
        stageBackground.addChild(background);
    }

    // Render the stage
    renderer.backgroundColor = 0xFFFFFF;
    if (characterBackgroundImage) {
        renderer.backgroundColor = 0x1B1B1B
    }
    renderer.view.style.position = "relative";
    renderer.view.style.display = "block";
    renderer.render(stage);

    // Show canvas
    $match.show();

    return [stageObjects, stageLayers, stageBackground, layer]
}

function showViewSpecialSegmentPageGraphic(segment, segmentAction) {
    let rendererData = resetMatchGraphics();
    let stageObjects = rendererData[0];
    let stageLayers = rendererData[1];
    let stageBackground = rendererData[2];
    let layer = rendererData[3];
    let el = $('#match-graphics');
    let segmentGraphics = segment['graphics'];
    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, segmentGraphics, segment, el,
        false, segmentAction);
}

function showPlaySegmentPageGraphic(segment, segmentAction = false) {
    let rendererData = resetMatchGraphics();
    let stageObjects = rendererData[0];
    let stageLayers = rendererData[1];
    let stageBackground = rendererData[2];
    let layer = rendererData[3];
    let el = $('#match-graphics');
    let segmentGraphics = segment['graphics'];
    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, segmentGraphics, segment, el,
        false, segmentAction);
    return stageLayers;
}

function showPlayMatchPageGraphic(match) {
    let rendererData = resetMatchGraphics();
    let stageObjects = rendererData[0];
    let stageLayers = rendererData[1];
    let stageBackground = rendererData[2];
    let layer = rendererData[3];
    let el = $('#match-graphics');
    let matchGraphics = match['graphics'];
    loadGraphic(stage, stageObjects, stageLayers, stageBackground, layer, matchGraphics, match, el,
        false);
    return stageLayers;
}

function turnMatchOrSegmentLoserGraphicOpaque(segment, winnerName, stageLayers) {
    // Create new layer of all losing team layers (for opacity change to be applied uniformly on each sprite)
    if (segment['graphics'].length > 0) {
        let losingLayer = new PIXI.display.Layer();
        stage.addChild(losingLayer);

        // Show popularity changes next to wrestler's names
        $(".match-wrestler").each(function (index) {
            let wrestlerDiv = $(this);
            let wrestlerName = wrestlerDiv.text();
            if (wrestlerDiv.attr('data-name')) {
                wrestlerName = wrestlerDiv.attr('data-name')
            }
            if (!(wrestlerName === winnerName)) {
                // Add losing team layers' children to losingLayer
                if (index < stageLayers.children.length) {
                    stageLayers.children[index].children.forEach(function (item) {
                        item._activeChildren.forEach(function (itemSprite) {
                            itemSprite.parentLayer = losingLayer;
                        });
                    });
                }
            }
        });

        // Make losingLayer opaque
        let filter = new PIXI.filters.AlphaFilter();
        filter.alpha = 0.35;
        losingLayer.filters = [filter];
        losingLayer.group.enableSort = true;
        renderer.render(stage);
    }
}

function pickUsingWeights(items, weights, mathRandomResult) {
    let total = 0;
    let ranges = weights.slice(0);
    let i;
    let len;
    for (i = 0, len = weights.length; i < len; i++) {
        ranges[i] = [total, total += ranges[i]];
    }
    if (!mathRandomResult) {
        mathRandomResult = Math.random()
    }
    let randomNumber = parseInt(mathRandomResult * total);
    for (; randomNumber < ranges[--i][0];);
    return items[i];
}

function addSpriteToStage(sprite, color, stageObjects, layer) {
    sprite.designs.map(function (x) {
        x.sprite.parentLayer = layer;
        x.sprite.zIndex = x.zIndex;
        x.defaultColor = color;
        x.sprite.tint = color;
        stageObjects.addChild(x.sprite);
    });
}

export {showTalentInformationGraphic, showRosterMemberPageGraphic, showFactionDetailsPageGraphic,
    characterBackgroundImage, showStaffMemberPageGraphic, showChangeAppearancePageGraphic, showEventPosterPageGraphic,
    showViewSpecialSegmentPageGraphic, showTitlePageGraphic, showAddChampionshipPageGraphic, showTalentDialogPageGraphic,
    resetAddSuperstarGraphic, showChampionshipInformationGraphic, showFactionInformationGraphic,
    showPlaySegmentPageGraphic, turnMatchOrSegmentLoserGraphicOpaque, showPlayMatchPageGraphic, copyToClipboard,
    showCustomStartingCompanyChampionshipGraphic, changeCharacterBackgroundImage, resetCommunityGraphicsGraphic,
    showScenarioEditorSuperstarGraphic, showScenarioEditorChampionshipGraphic, showDialogPersonGraphic}